import { ɵɵinject, ɵɵdefineInjectable, ɵsetClassMetadata, Injectable, Optional, ɵɵelement, ɵɵpipe, ɵɵnextContext, ɵɵproperty, ɵɵpipeBind2, ɵɵsanitizeHtml, ɵɵelementStart, ɵɵelementEnd, ɵɵadvance, ɵɵpipeBind1, ɵɵtext, ɵɵtextInterpolate1, ɵɵtemplate, ɵɵelementContainer, EventEmitter, ɵɵdirectiveInject, ɵɵdefineComponent, ɵɵlistener, ɵɵpureFunction1, ɵɵpureFunction2, Component, Input, Output, ɵɵelementContainerStart, ɵɵelementContainerEnd, ɵɵtextInterpolate, ɵɵreference, ɵɵclassMapInterpolate1, ɵɵclassProp, ɵɵgetCurrentView, ɵɵrestoreView, ɵɵdefineDirective, Directive, ɵɵcontentQuery, TemplateRef, ɵɵqueryRefresh, ɵɵloadQuery, ContentChildren, ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, NgModule, SkipSelf } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject, BehaviorSubject } from 'rxjs';
import { Md5 } from 'ts-md5/dist/md5';
import * as jwt_decode_ from 'jwt-decode';
import { isNullOrUndefined } from 'util';
import { ActivatedRoute, Router } from '@angular/router';
import { PathService, HttpService } from '@akeela/properties';
import { LocalService } from '@akeela/local-storage';
import swal from 'sweetalert2';
import { I18nPipe, I18nModule } from '@akeela/i18n';
import { __awaiter, __decorate, __param, __metadata } from 'tslib';
import { Validators, FormBuilder, ɵangular_packages_forms_forms_y, NgControlStatusGroup, FormGroupDirective, DefaultValueAccessor, NgControlStatus, FormControlName, SelectControlValueAccessor, NgSelectOption, ɵangular_packages_forms_forms_x, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ErrorService as ErrorService$1, UtilsService, CountdownService } from '@akeela/common';
import { NgIf, NgClass, NgTemplateOutlet, NgForOf, CommonModule } from '@angular/common';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { Keepalive, NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { SwalPortalTargets, SwalDirective, SwalComponent, SwalPortalDirective, SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { AlertService, AlertModule } from '@akeela/alert';

class AuthConfigConst {
}
AuthConfigConst.activeEncrypt = false;
AuthConfigConst.hasProfiles = false;

class AuthConfig {
}

class AuthConfigService {
    constructor(config) {
        this.kaadConfig = new AuthConfig();
        if (config) {
            this.options = config;
        }
    }
    set options(opt) {
        this.kaadConfig.activeEncrypt = (opt && opt.activeEncrypt) ? opt.activeEncrypt : AuthConfigConst.activeEncrypt;
        this.kaadConfig.hasProfiles = (opt && opt.hasProfiles) ? opt.hasProfiles : AuthConfigConst.hasProfiles;
    }
    get isEncryptActive() {
        return this.kaadConfig.activeEncrypt ? this.kaadConfig.activeEncrypt : false;
    }
    get hasProfilesActive() {
        return this.kaadConfig.hasProfiles ? this.kaadConfig.hasProfiles : false;
    }
}
/** @nocollapse */ AuthConfigService.ɵfac = function AuthConfigService_Factory(t) { return new (t || AuthConfigService)(ɵɵinject(AuthConfig, 8)); };
/** @nocollapse */ AuthConfigService.ɵprov = ɵɵdefineInjectable({ token: AuthConfigService, factory: AuthConfigService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AuthConfigService, [{
        type: Injectable
    }], function () { return [{ type: AuthConfig, decorators: [{
                type: Optional
            }] }]; }, null); })();

class KeepAliveService {
    constructor() {
        this.userLoggedIn = new Subject();
        this.resetIdle = new Subject();
        this.userLoggedIn.next(false);
        // if (this._auth.isAuthenticated()) {
        //     this.userLoggedIn.next(true);
        // } else {
        //     this.userLoggedIn.next(false);
        // }
    }
    setUserLoggedIn(userLoggedIn) {
        this.userLoggedIn.next(userLoggedIn);
    }
    getUserLoggedIn() {
        return this.userLoggedIn.asObservable();
    }
    setReset() {
        this.resetIdle.next(true);
    }
    getResetObservable() {
        return this.resetIdle.asObservable();
    }
}
/** @nocollapse */ KeepAliveService.ɵfac = function KeepAliveService_Factory(t) { return new (t || KeepAliveService)(); };
/** @nocollapse */ KeepAliveService.ɵprov = ɵɵdefineInjectable({ token: KeepAliveService, factory: KeepAliveService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(KeepAliveService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

const TOKEN_NAME = 'access-token';
const jwt_decode = jwt_decode_;
class AuthService {
    constructor(http, path, route, router, _httpService, _configService, localStorage, keepaliveService) {
        this.http = http;
        this.path = path;
        this.route = route;
        this.router = router;
        this._httpService = _httpService;
        this._configService = _configService;
        this.localStorage = localStorage;
        this.keepaliveService = keepaliveService;
        this.detect_exp_jwt = new Subject();
        this.queryParams = {};
        this.isAuth$ = new BehaviorSubject(false);
        this.idleonTimeout$ = new BehaviorSubject(null);
        this.idleonIdleStart$ = new BehaviorSubject(null);
        this.idleonTimeoutWarning$ = new BehaviorSubject(null);
        this.idleonInterrupt$ = new BehaviorSubject(null);
        this.idleonreset$ = new BehaviorSubject(null);
        this.showChangePassword$ = new BehaviorSubject(false);
        this.coreLogin$ = new BehaviorSubject(null);
        if (this.isAuthenticated()) {
            this.setisAuth(true);
        }
    }
    setCoreLogin(coreLogin) {
        this.coreLogin$.next(coreLogin);
    }
    setidleonreset(idleonreset) {
        this.idleonreset$.next(idleonreset);
    }
    setShowChangePassword(showChangePassword) {
        this.showChangePassword$.next(showChangePassword);
    }
    setidleonTimeout(idleonTimeout) {
        this.idleonTimeout$.next(idleonTimeout);
    }
    setidleonIdleStart(idleonIdleStart) {
        this.idleonIdleStart$.next(idleonIdleStart);
    }
    setidleonTimeoutWarning(idleonTimeoutWarning) {
        this.idleonTimeoutWarning$.next(idleonTimeoutWarning);
    }
    setidleonInterrupt(idleonInterrupt) {
        this.idleonInterrupt$.next(idleonInterrupt);
    }
    get_detect_exp_jwt() {
        return this.detect_exp_jwt.asObservable();
    }
    set_detect_exp_jwt() {
        this.detect_exp_jwt.next(true);
    }
    isActiveProfile(token) {
        if (this._configService.hasProfilesActive) {
            console.log('PASA');
            if (!isNullOrUndefined(token)) {
                const decoded = jwt_decode(token);
                if (!isNullOrUndefined(decoded.profile)) {
                    return true;
                }
                else {
                    return false;
                }
            }
        }
        else {
            console.log('NO PASA');
            return true;
        }
    }
    getSession() {
        if (this.getToken() != null) {
            const token = this.getToken();
            if (!isNullOrUndefined(token)) {
                const decoded = jwt_decode(token);
                if (decoded.sub === '') {
                    return '';
                }
                else {
                    return decoded;
                }
            }
        }
        return null;
    }
    getInitials() {
        const token = this.getToken();
        const decoded = jwt_decode(token);
        if (decoded.firstName === undefined) {
            return 0;
        }
        return decoded.firstName.substr(0, 1) + decoded.lastName.substr(0, 1);
    }
    getUsername() {
        let username = null;
        const token = this.getToken();
        if (!isNullOrUndefined(token)) {
            const decoded = jwt_decode(token);
            if (decoded.sub === '') {
                return '';
            }
            username = decoded.sub;
        }
        return username;
    }
    getEmailUser() {
        const token = this.getToken();
        const decoded = jwt_decode(token);
        if (decoded.email === '') {
            return '';
        }
        return decoded.email;
    }
    getUserAudience() {
        const token = this.getToken();
        const decoded = jwt_decode(token);
        if (decoded.audience === '') {
            return '';
        }
        return decoded.audience;
    }
    getPersonIdentifier() {
        const token = this.getToken();
        const decoded = jwt_decode(token);
        if (decoded.personIdentifier === '') {
            return '';
        }
        return decoded.personIdentifier;
    }
    getAdminOrganizationIdentifier() {
        const token = this.getToken();
        const decoded = jwt_decode(token);
        if (decoded.adminOrganizationIdentifier === '') {
            return '';
        }
        return decoded.adminOrganizationIdentifier;
    }
    isAuthenticated() {
        if (this.getToken() != null) {
            if (this.isTokenExpired() === 1) {
                if (!this.isAuth$.getValue()) {
                    this.setisAuth(true);
                }
                return true;
            }
        }
        if (this.isAuth$.getValue()) {
            this.setisAuth(false);
        }
        return false;
    }
    getToken() {
        return this.localStorage.getItem(TOKEN_NAME);
    }
    setToken(token) {
        this.localStorage.setItem(TOKEN_NAME, token);
    }
    getTokenExpirationDate(token) {
        const decoded = jwt_decode(token);
        if (decoded.exp === undefined) {
            return null;
        }
        const date = new Date(0);
        date.setUTCSeconds(decoded.exp);
        return date;
    }
    encryptPassword(password) {
        if (this._configService.isEncryptActive) {
            const md5 = new Md5();
            return md5.appendStr(password).end();
        }
        else {
            return password;
        }
    }
    /**
     * RETURNS
     *
     * 0-> SIN TOKEN
     * 1-> ACTIVO
     * 2-> VENCIDO
     * 3-> INVALIDO
     * @stable
     */
    isTokenExpired(token) {
        if (!token) {
            token = this.getToken();
        }
        if (!token) {
            return 0;
        }
        const date = this.getTokenExpirationDate(token);
        if (date === undefined) {
            return 3;
        }
        // if(!(date.valueOf() > new Date().valueOf())) return 2
        return 1;
    }
    setSession(user) {
        if (user && user.token) {
            this.localStorage.removeItem('activate_validation');
            this.localStorage.setItem('user', JSON.stringify(user));
            this.localStorage.setItem(TOKEN_NAME, user.token);
            if (!isNullOrUndefined(user['refresh-token'])) {
                this.localStorage.setItem('refresh-token', user['refresh-token']);
            }
        }
    }
    handleLogout(noProfile) {
        this.keepaliveService.setUserLoggedIn(false);
        this.localStorage.clear();
        if (noProfile) {
            swal.fire({
                title: 'Error!',
                html: 'El usuario no posee perfil vinculado, por favor indiquelo al administrador del sistema.'
            });
        }
    }
    logout(noProfile) {
        debugger;
        const logoutName = 'person$logout$delete';
        this.path.getPathService(logoutName).subscribe(response => {
            const username = this.getUsername();
            const params = { username };
            const url = response.url;
            this.http.delete(url, { params }).subscribe(responseLogout => {
                if (noProfile) {
                    this.handleLogout(noProfile);
                }
                else {
                    this.handleLogout();
                }
            }, error => {
                this.handleLogout();
            });
        });
    }
    setisAuth(isAuth) {
        this.isAuth$.next(isAuth);
    }
    get isAuth() {
        return this.isAuth$;
    }
}
/** @nocollapse */ AuthService.ɵfac = function AuthService_Factory(t) { return new (t || AuthService)(ɵɵinject(HttpClient), ɵɵinject(PathService), ɵɵinject(ActivatedRoute), ɵɵinject(Router), ɵɵinject(HttpService), ɵɵinject(AuthConfigService), ɵɵinject(LocalService), ɵɵinject(KeepAliveService)); };
/** @nocollapse */ AuthService.ɵprov = ɵɵdefineInjectable({ token: AuthService, factory: AuthService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AuthService, [{
        type: Injectable
    }], function () { return [{ type: HttpClient }, { type: PathService }, { type: ActivatedRoute }, { type: Router }, { type: HttpService }, { type: AuthConfigService }, { type: LocalService }, { type: KeepAliveService }]; }, null); })();

class AkeelaTemplateService {
    constructor() {
        this.templates = {};
    }
    addTemplate(componentName, template) {
        this.templates[componentName] = template;
    }
    getTemplates() {
        return this.templates;
    }
    getTemplate(componentName) {
        return this.templates[componentName];
    }
}
/** @nocollapse */ AkeelaTemplateService.ɵfac = function AkeelaTemplateService_Factory(t) { return new (t || AkeelaTemplateService)(); };
/** @nocollapse */ AkeelaTemplateService.ɵprov = ɵɵdefineInjectable({ token: AkeelaTemplateService, factory: AkeelaTemplateService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AkeelaTemplateService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class ErrorService {
    constructor(i18n) {
        this.i18n = i18n;
    }
    show(error, title_msg, default_msg) {
        console.log(error);
        if (error.status === 401) {
            swal.fire({
                title: title_msg ? this.i18n.transform(title_msg) : this.i18n.transform(this.error_text(error)),
                text: '',
            });
        }
        else if (error.status === 400) {
            swal.fire({
                title: title_msg ? this.i18n.transform(title_msg) : this.i18n.transform(this.error_text(error)),
                text: default_msg ? this.i18n.transform(default_msg) : this.i18n.transform('@i18n-error-badrequest'),
            });
        }
        else {
            if (error.error.code !== undefined) {
                swal.fire({
                    title: title_msg ? this.i18n.transform(title_msg) : this.i18n.transform(this.error_text(error)),
                    html: '<span class=\'pull-right\'><small>' + error.error.code + '</small></span><br><br>' + (default_msg ? this.i18n.transform(default_msg) : this.i18n.transform(error.error.message))
                });
            }
            else {
                swal.fire({
                    title: title_msg ? this.i18n.transform(title_msg) : this.i18n.transform(this.error_text(error)),
                    html: default_msg ? this.i18n.transform(default_msg) : '' + (default_msg ? this.i18n.transform(default_msg) : this.i18n.transform(error.error.message))
                });
            }
        }
    }
    error_text(error) {
        switch (error.status) {
            case 500:
                return 'Error';
            case 401:
                return 'USER IS NOT AUTHORIZED';
            case 0:
                return 'NO INTERNET CONNECTION';
            default:
                return error.statusText;
        }
    }
}
/** @nocollapse */ ErrorService.ɵfac = function ErrorService_Factory(t) { return new (t || ErrorService)(ɵɵinject(I18nPipe)); };
/** @nocollapse */ ErrorService.ɵprov = ɵɵdefineInjectable({ token: ErrorService, factory: ErrorService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ErrorService, [{
        type: Injectable
    }], function () { return [{ type: I18nPipe }]; }, null); })();

function LoginComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 11);
    ɵɵpipe(1, "i18n");
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵproperty("innerHTML", ɵɵpipeBind2(1, 1, "@i18n-store-front-login-title", ctx_r0.lang), ɵɵsanitizeHtml);
} }
function LoginComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 11);
    ɵɵpipe(1, "i18n");
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵproperty("innerHTML", ɵɵpipeBind2(1, 1, "@i18n-store-front-login-title-coreLogin", ctx_r1.lang), ɵɵsanitizeHtml);
} }
function LoginComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 23);
    ɵɵelementStart(1, "div", 24);
    ɵɵelement(2, "i", 25);
    ɵɵelementEnd();
    ɵɵelementStart(3, "div", 26);
    ɵɵelement(4, "span", 11);
    ɵɵpipe(5, "i18n");
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext();
    ɵɵadvance(4);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(5, 1, ctx_r2.errors), ɵɵsanitizeHtml);
} }
function LoginComponent_div_20_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 11);
    ɵɵpipe(1, "i18n");
} if (rf & 2) {
    const ctx_r7 = ɵɵnextContext(2);
    ɵɵproperty("innerHTML", ɵɵpipeBind2(1, 1, "@i18n-store-front-login-error-field-required", ctx_r7.lang), ɵɵsanitizeHtml);
} }
function LoginComponent_div_20_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" M\u00EDnimo ", ctx_r8.usernameMinLength, " caracteres ");
} }
function LoginComponent_div_20_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" M\u00E1ximo ", ctx_r9.usernameMaxLength, " caracteres ");
} }
function LoginComponent_div_20_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 27);
    ɵɵtemplate(1, LoginComponent_div_20_div_1_Template, 2, 4, "div", 5);
    ɵɵtemplate(2, LoginComponent_div_20_div_2_Template, 2, 1, "div", 21);
    ɵɵtemplate(3, LoginComponent_div_20_div_3_Template, 2, 1, "div", 21);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r3.form.get("username").errors["required"] && !ctx_r3.form.get("username").pristine);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r3.form.get("username").hasError("minlength") && !ctx_r3.form.get("username").pristine);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r3.form.get("username").hasError("maxlength") && !ctx_r3.form.get("username").pristine);
} }
function LoginComponent_div_32_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 11);
    ɵɵpipe(1, "i18n");
} if (rf & 2) {
    const ctx_r10 = ɵɵnextContext(2);
    ɵɵproperty("innerHTML", ɵɵpipeBind2(1, 1, "@i18n-store-front-login-error-field-required", ctx_r10.lang), ɵɵsanitizeHtml);
} }
function LoginComponent_div_32_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" M\u00EDnimo ", ctx_r11.passwordMinLength, " caracteres ");
} }
function LoginComponent_div_32_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" M\u00E1ximo ", ctx_r12.passwordMaxLength, " caracteres ");
} }
function LoginComponent_div_32_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 27);
    ɵɵtemplate(1, LoginComponent_div_32_div_1_Template, 2, 4, "div", 5);
    ɵɵtemplate(2, LoginComponent_div_32_div_2_Template, 2, 1, "div", 21);
    ɵɵtemplate(3, LoginComponent_div_32_div_3_Template, 2, 1, "div", 21);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r4.form.get("password").errors["required"] && !ctx_r4.form.get("password").pristine);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r4.form.get("password").hasError("minlength") && !ctx_r4.form.get("password").pristine);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r4.form.get("password").hasError("maxlength") && !ctx_r4.form.get("password").pristine);
} }
function LoginComponent_span_39_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span");
    ɵɵelement(1, "i", 28);
    ɵɵelementEnd();
} }
function LoginComponent_ng_container_40_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainer(0);
} }
const _c0 = function (a0) { return { "error": a0 }; };
const _c1 = function (a0, a1) { return { " fa-eye": a0, "fa-eye-slash": a1 }; };
class LoginComponent {
    constructor(templateService, route, router, formBuilder, _sanitizer, _httpService, _error, _auth, _http, _i18n, localStorage, keepaliveService, utilService) {
        this.templateService = templateService;
        this.route = route;
        this.router = router;
        this.formBuilder = formBuilder;
        this._sanitizer = _sanitizer;
        this._httpService = _httpService;
        this._error = _error;
        this._auth = _auth;
        this._http = _http;
        this._i18n = _i18n;
        this.localStorage = localStorage;
        this.keepaliveService = keepaliveService;
        this.utilService = utilService;
        this.useHttp = false;
        this.response = new EventEmitter();
        this.templates = {};
        this.object = {};
        this.submit_disabled = false;
        this.errors = '';
        this.typeInputPass = false;
    }
    ngOnInit() {
        this._auth.coreLogin$.subscribe(data => {
            this.coreLogin = data;
            if (this.coreLogin) {
                this.form = this.formBuilder.group({
                    username: ['', [Validators.required]],
                    password: ['', [Validators.required]],
                });
            }
            else {
                this.form = this.formBuilder.group({
                    username: ['', [Validators.required, Validators.minLength(this.usernameMinLength), Validators.maxLength(this.usernameMaxLength)]],
                    password: ['', [Validators.required, Validators.minLength(this.passwordMinLength), Validators.maxLength(this.passwordMaxLength)]]
                });
            }
        });
        this.usernameMinLength = this.params.formsValidations.username.minLength ? parseInt(this.params.formsValidations.username.minLength) : 6;
        this.usernameMaxLength = this.params.formsValidations.username.maxLength ? parseInt(this.params.formsValidations.username.maxLength) : 12;
        this.passwordMinLength = this.params.formsValidations.password.minLength ? parseInt(this.params.formsValidations.password.minLength) : 8;
        this.passwordMaxLength = this.params.formsValidations.password.maxLength ? parseInt(this.params.formsValidations.password.maxLength) : 12;
        this.route.queryParams.subscribe(queryParams => {
            let tempRedirectUrl = queryParams.redirectUrl ? queryParams.redirectUrl != 'endpoint' ? queryParams.redirectUrl : null : null;
            let tempResponseType = queryParams.responseType ? !isNullOrUndefined(tempRedirectUrl) ? queryParams.responseType : null : null;
            this.clientCode = isNullOrUndefined(queryParams.clientCode) ? this.params.clientCode : queryParams.clientCode;
            this.responseType = isNullOrUndefined(queryParams.responseType) ? 'TOKEN' : queryParams.responseType;
            this.endpoint = isNullOrUndefined(tempRedirectUrl) ? this.endpoint : tempRedirectUrl;
            this.useHttp = !isNullOrUndefined(tempResponseType);
        });
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.templates = this.templateService.getTemplates();
        }, 10);
    }
    viewPassword() {
        this.typeInputPass = !(this.typeInputPass);
    }
    submit() {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            this.localStorage.removeItem('modeUpdatePass');
            this.errors = '';
            if (this.form.dirty && this.form.valid) {
                this.submit_disabled = true;
                this.password = this.form.get('password').value;
                if (this.coreLogin) {
                    let dataCore;
                    if (this.localStorage.getItem('identityCore')) {
                        dataCore = JSON.parse(this.localStorage.getItem('identityCore'));
                    }
                    this.object = {
                        endpoint: {
                            login: {
                                name: this.endpoint,
                                params: {
                                    path: {},
                                    request: {},
                                    body: {
                                        identifier: this.form.get('username').value,
                                        password: this.form.get('password').value,
                                        personMarketType: {
                                            identifier: "NATURAL"
                                        },
                                        person: {
                                            identity: ((_b = (_a = dataCore === null || dataCore === void 0 ? void 0 : dataCore.person) === null || _a === void 0 ? void 0 : _a.identity) === null || _b === void 0 ? void 0 : _b.type_identity) + ((_d = (_c = dataCore === null || dataCore === void 0 ? void 0 : dataCore.person) === null || _c === void 0 ? void 0 : _c.identity) === null || _d === void 0 ? void 0 : _d.identity)
                                        },
                                    }
                                }
                            }
                        }
                    };
                }
                else {
                    this.object = {
                        endpoint: {
                            login: {
                                name: this.endpoint,
                                params: {
                                    path: {},
                                    request: {
                                        username: this.form.get('username').value,
                                        password: this._auth.encryptPassword(this.form.get('password').value),
                                        rol: this.params.role,
                                        clientCode: this.clientCode,
                                        responseType: this.responseType,
                                        ip: yield this.getIp()
                                    },
                                    body: {}
                                }
                            }
                        }
                    };
                }
                this.username = this.form.get('username').value;
                if (this.useHttp) {
                    this.useHttpClient(this.object);
                }
                else {
                    this.useHttpService(this.object);
                }
            }
        });
    }
    getIp() {
        return this.utilService.getIPAddress();
    }
    useHttpClient(httpObject) {
        alert('');
        this._http
            .post(this.object.endpoint.login.name, {}, { params: this.object.endpoint.login.params.request })
            .subscribe(response => this.responseHandle(response), error => this.errorHandle(error));
    }
    useHttpService(httpObject) {
        this._httpService
            .executeRequest(this.object.endpoint.login.name, this.object.endpoint.login.params)
            .subscribe(response => {
            this.responseHandle(response);
        }, error => {
            this.errorHandle(error);
        });
    }
    responseHandle(response) {
        if (!isNullOrUndefined(response.token)) {
            // antes de setear la sesión, valido el profile...
            if (this._auth.isActiveProfile(response.token)) {
                this._auth.setSession(response);
                if (this._auth.isAuthenticated()) {
                    this.keepaliveService.setUserLoggedIn(true);
                    this.response.emit(this._auth.isAuthenticated());
                }
                else {
                    this._error.show(null, '@i18n-login-error-login', '@i18n-login-error-text-login');
                    this.form.get('password').setValue('');
                    this.form.get('password').patchValue('');
                    this.submit_disabled = false;
                }
            }
            else {
                if (this.sessionType === 'QUESTION') {
                }
                else {
                    this._error.show(null, '@i18n-login-error-login', '@i18n-auth-not-user-profile');
                }
                this.submit_disabled = false;
            }
        }
    }
    errorHandle(error) {
        console.log(error);
        /*
        if (error.error.name === 'ValidationException') {
            this.error.show(error, '@i18n-login-error-user-inactive', '@i18n-login-error-user-inactive-text');
        } else if (error.error.name === 'RequiresManualUnlockingException') {
            this._error.show(error, '@i18n-login-error-user-restricted', '@i18n-login-error-user-restricted-text');
        } else if (error.error.name === 'UserLockedException') {
            this._error.show(error, '@i18n-login-error-user-block', '@i18n-login-error-user-block-text');
        } else if (error.error.name === 'BadCredentialsException') {
            this._error.show(error);
        } else if (error.error.name === 'UserAlreadyLoggedException') {
            this._error.show(error, '', '@i18n-error-user-has-already-login');
        } else {
            this._error.show(error);
        }

*/
        this.errors = '';
        if (error.error.name === 'ValidationException') {
            if (!isNullOrUndefined(error.error.message)) {
                const message = error.error.message;
                this.errors = message;
            }
            else {
                this.errors = '@i18n-login-error-user-inactive';
            }
        }
        else if (error.error.name === 'RequiresManualUnlockingException') {
            this.errors = '@i18n-login-error-user-restricted-text';
        }
        else if (error.error.name === 'UserLockedException') {
            this.errors = '@i18n-login-error-user-block-text';
        }
        else if (error.error.name === 'BadCredentialsException') {
            this.errors = error.error.message;
            if (this.coreLogin) {
                this.errors = `${error.error.message}-core`;
            }
        }
        else if (error.error.name === 'UserAlreadyLoggedException') {
            if (error.error.message === '@i18n-question-user-has-already-logged-in') {
                swal.fire({
                    title: '',
                    showCancelButton: true,
                    showCloseButton: true,
                    showConfirmButton: true,
                    confirmButtonText: this._i18n.transform('@i18n-popup-text-yes'),
                    cancelButtonText: this._i18n.transform('@i18n-popup-text-no'),
                    reverseButtons: true,
                    html: '<p>' + this._i18n.transform('@i18n-question-user-has-already-logged-in') + '</p>',
                }).then((result) => {
                    if (!isNullOrUndefined(result.value) && result.value) {
                        this.closeSessionAndLogin();
                    }
                    else {
                        this.form.get('password').setValue('');
                        this.form.get('password').patchValue('');
                        this.submit_disabled = false;
                    }
                });
            }
            else {
                this.errors = '@i18n-error-user-has-already-login';
            }
        }
        else {
            if (error.error.name === 'NullArgumentException') {
                const message = error.error.messageLabel;
                if (message === '@i18n-error-message-user-password-expired') {
                    swal.fire({
                        title: '',
                        showCancelButton: true,
                        showCloseButton: true,
                        showConfirmButton: true,
                        confirmButtonText: this._i18n.transform('@i18n-popup-text-yes'),
                        cancelButtonText: this._i18n.transform('@i18n-popup-text-no'),
                        reverseButtons: true,
                        html: '<p>' + this._i18n.transform('@i18n-error-message-user-password-expired') + '</p>',
                    }).then((result) => {
                        if (!isNullOrUndefined(result.value) && result.value) {
                            this.localStorage.setItem('modeUpdatePass', this.username);
                            this.router.navigateByUrl(this.router.createUrlTree(['change-password/' + this.username + '/' + error.error.titleLabel], {
                                queryParams: {}
                            }));
                        }
                        else {
                            this.localStorage.removeItem('modeUpdatePass');
                        }
                    });
                }
                else {
                    this._error.show(error);
                }
            }
            else {
                this._error.show(error);
            }
        }
        if (error.error.message !== '@i18n-question-user-has-already-logged-in') {
            this.form.get('password').setValue('');
            this.form.get('password').patchValue('');
            this.submit_disabled = false;
        }
    }
    closeSessionAndLogin() {
        return __awaiter(this, void 0, void 0, function* () {
            this.submit_disabled = true;
            this.object = {
                endpoint: {
                    login: {
                        name: 'person$invalidate_session_login$post',
                        params: {
                            path: {},
                            request: {
                                username: this.form.get('username').value,
                                password: this._auth.encryptPassword(this.password),
                                rol: this.params.role,
                                clientCode: this.clientCode,
                                responseType: this.responseType,
                                ip: yield this.getIp()
                            },
                            body: {}
                        }
                    }
                }
            };
            this.username = this.form.get('username').value;
            if (this.useHttp) {
                this.useHttpClient(this.object);
            }
            else {
                this.useHttpService(this.object);
            }
        });
    }
}
/** @nocollapse */ LoginComponent.ɵfac = function LoginComponent_Factory(t) { return new (t || LoginComponent)(ɵɵdirectiveInject(AkeelaTemplateService), ɵɵdirectiveInject(ActivatedRoute), ɵɵdirectiveInject(Router), ɵɵdirectiveInject(FormBuilder), ɵɵdirectiveInject(DomSanitizer), ɵɵdirectiveInject(HttpService), ɵɵdirectiveInject(ErrorService$1), ɵɵdirectiveInject(AuthService), ɵɵdirectiveInject(HttpClient), ɵɵdirectiveInject(I18nPipe), ɵɵdirectiveInject(LocalService), ɵɵdirectiveInject(KeepAliveService), ɵɵdirectiveInject(UtilsService)); };
/** @nocollapse */ LoginComponent.ɵcmp = ɵɵdefineComponent({ type: LoginComponent, selectors: [["akeela-login"]], inputs: { endpoint: "endpoint", params: "params", useHttp: "useHttp", sessionType: "sessionType" }, outputs: { response: "response" }, decls: 41, vars: 40, consts: [[1, "fluid-container", "text-center"], [1, "flexbox-container"], [1, "ml-auto", "mr-auto"], [1, "ml-auto", "mr-auto", "p-3", "p-md-auto"], [1, "teme-gray", "box", "pt-2", "pb-2", "p-1", "pt-md-4", "pb-md-4", "p-3"], [3, "innerHTML", 4, "ngIf"], ["class", "mb-4 text-left p-3 box-errors", 4, "ngIf"], ["novalidate", "", 1, "text-left", 3, "formGroup", "ngSubmit"], [1, "row"], [1, "form-group", "col-12"], [1, "label", "font-weight-normal", 2, "word-wrap", "break-word"], [3, "innerHTML"], [1, "text-danger", "mt-1"], ["type", "text", "formControlName", "username", 1, "form-control", 3, "placeholder", "ngClass"], ["class", "form-control-feedback help-block", 4, "ngIf"], [1, "input-group"], ["formControlName", "password", 1, "form-control", 3, "placeholder", "type", "ngClass"], [1, "input-group-append"], [1, "pt-2", "far", "cursor-pounter", "input-group-text", 3, "ngClass", "click"], [1, "col-12"], ["type", "submit", 1, "btn", "btn-block", "btn-primary", "btn-lg", 3, "disabled"], [4, "ngIf"], [4, "ngTemplateOutlet"], [1, "mb-4", "text-left", "p-3", "box-errors"], [1, "d-inline-flex", "w-10"], [1, "fas", "fa-info-circle", "pr-2"], [1, "d-inline-flex", "w-90"], [1, "form-control-feedback", "help-block"], [1, "fa", "fa-spinner", "fa-spin"]], template: function LoginComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelementStart(2, "div", 2);
        ɵɵelementStart(3, "div", 0);
        ɵɵelementStart(4, "div", 1);
        ɵɵelementStart(5, "div", 3);
        ɵɵelementStart(6, "div", 4);
        ɵɵtemplate(7, LoginComponent_div_7_Template, 2, 4, "div", 5);
        ɵɵtemplate(8, LoginComponent_div_8_Template, 2, 4, "div", 5);
        ɵɵtemplate(9, LoginComponent_div_9_Template, 6, 3, "div", 6);
        ɵɵelementStart(10, "form", 7);
        ɵɵlistener("ngSubmit", function LoginComponent_Template_form_ngSubmit_10_listener() { return ctx.submit(); });
        ɵɵelementStart(11, "div", 8);
        ɵɵelementStart(12, "div", 9);
        ɵɵelementStart(13, "label", 10);
        ɵɵelement(14, "span", 11);
        ɵɵpipe(15, "i18n");
        ɵɵelementStart(16, "span", 12);
        ɵɵtext(17, " * ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelement(18, "input", 13);
        ɵɵpipe(19, "i18n");
        ɵɵtemplate(20, LoginComponent_div_20_Template, 4, 3, "div", 14);
        ɵɵelementEnd();
        ɵɵelementStart(21, "div", 9);
        ɵɵelementStart(22, "label", 10);
        ɵɵelement(23, "span", 11);
        ɵɵpipe(24, "i18n");
        ɵɵelementStart(25, "span", 12);
        ɵɵtext(26, " * ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(27, "div", 15);
        ɵɵelement(28, "input", 16);
        ɵɵpipe(29, "i18n");
        ɵɵelementStart(30, "div", 17);
        ɵɵelementStart(31, "i", 18);
        ɵɵlistener("click", function LoginComponent_Template_i_click_31_listener() { return ctx.viewPassword(); });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵtemplate(32, LoginComponent_div_32_Template, 4, 3, "div", 14);
        ɵɵelementEnd();
        ɵɵelement(33, "br");
        ɵɵelementStart(34, "div", 19);
        ɵɵelementStart(35, "button", 20);
        ɵɵelement(36, "span", 11);
        ɵɵpipe(37, "i18n");
        ɵɵtext(38, "\u00A0 ");
        ɵɵtemplate(39, LoginComponent_span_39_Template, 2, 0, "span", 21);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵtemplate(40, LoginComponent_ng_container_40_Template, 1, 0, "ng-container", 22);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(7);
        ɵɵproperty("ngIf", !ctx.coreLogin);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.coreLogin);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.errors != "");
        ɵɵadvance(1);
        ɵɵproperty("formGroup", ctx.form);
        ɵɵadvance(4);
        ɵɵproperty("innerHTML", ɵɵpipeBind2(15, 18, "@i18n-store-front-login-form-username", ctx.lang), ɵɵsanitizeHtml);
        ɵɵadvance(4);
        ɵɵproperty("placeholder", ɵɵpipeBind2(19, 21, "@i18n-store-front-login-form-username", ctx.lang))("ngClass", ɵɵpureFunction1(33, _c0, ctx.form.controls.username.invalid && ctx.form.controls.username.dirty));
        ɵɵadvance(2);
        ɵɵproperty("ngIf", ctx.form.get("username").errors);
        ɵɵadvance(3);
        ɵɵproperty("innerHTML", ɵɵpipeBind2(24, 24, "@i18n-store-front-login-form-password", ctx.lang), ɵɵsanitizeHtml);
        ɵɵadvance(5);
        ɵɵproperty("placeholder", ɵɵpipeBind2(29, 27, "@i18n-store-front-login-form-password", ctx.lang))("type", !ctx.typeInputPass ? "password" : "text")("ngClass", ɵɵpureFunction1(35, _c0, ctx.form.controls.password.invalid && ctx.form.controls.password.dirty));
        ɵɵadvance(3);
        ɵɵproperty("ngClass", ɵɵpureFunction2(37, _c1, ctx.typeInputPass, !ctx.typeInputPass));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.form.get("password").errors);
        ɵɵadvance(3);
        ɵɵproperty("disabled", !ctx.form.valid || ctx.submit_disabled);
        ɵɵadvance(1);
        ɵɵproperty("innerHTML", ɵɵpipeBind2(37, 30, "@i18n-store-front-login-form-btn-submit", ctx.lang), ɵɵsanitizeHtml);
        ɵɵadvance(3);
        ɵɵproperty("ngIf", ctx.submit_disabled);
        ɵɵadvance(1);
        ɵɵproperty("ngTemplateOutlet", ctx.templates["loginLinks"]);
    } }, directives: [NgIf, ɵangular_packages_forms_forms_y, NgControlStatusGroup, FormGroupDirective, DefaultValueAccessor, NgControlStatus, FormControlName, NgClass, NgTemplateOutlet], pipes: [I18nPipe], styles: [".box[_ngcontent-%COMP%]{box-shadow:0 2px 4px 0 hsla(0,0%,60%,.5);margin-left:auto;margin-right:auto;width:25rem}.box[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{margin-bottom:2.5rem}@media (max-width:26.875rem){.box[_ngcontent-%COMP%]{width:100%}}.label2[_ngcontent-%COMP%]{font-size:.7rem;margin-top:.3rem}.link[_ngcontent-%COMP%]{font-size:.875rem}.ls[_ngcontent-%COMP%]{letter-spacing:-2px}.ls-o[_ngcontent-%COMP%]{color:#777}.cursor-pounter[_ngcontent-%COMP%]{cursor:pointer}.box-errors[_ngcontent-%COMP%]{background:#fff;border:2px solid #f9f1f1;border-radius:20px;box-shadow:0 2px 1px 0 hsla(0,0%,60%,.1);color:#a94442;font-size:14px;white-space:unset}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(LoginComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-login',
                templateUrl: './login.component.html',
                styleUrls: ['./login.component.css']
            }]
    }], function () { return [{ type: AkeelaTemplateService }, { type: ActivatedRoute }, { type: Router }, { type: FormBuilder }, { type: DomSanitizer }, { type: HttpService }, { type: ErrorService$1 }, { type: AuthService }, { type: HttpClient }, { type: I18nPipe }, { type: LocalService }, { type: KeepAliveService }, { type: UtilsService }]; }, { endpoint: [{
            type: Input
        }], params: [{
            type: Input
        }], useHttp: [{
            type: Input
        }], sessionType: [{
            type: Input
        }], response: [{
            type: Output
        }] }); })();

function KeepaliveComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 4);
    ɵɵelementStart(2, "div", 5);
    ɵɵelement(3, "br");
    ɵɵelement(4, "br");
    ɵɵelementStart(5, "p");
    ɵɵelementStart(6, "strong");
    ɵɵtext(7);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelement(8, "br");
    ɵɵelement(9, "br");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(7);
    ɵɵtextInterpolate(ctx_r1.idleState);
} }
class KeepaliveComponent {
    constructor(swalTargets, idle, keepalive, _auth, _router, keepaliveService) {
        this.swalTargets = swalTargets;
        this.idle = idle;
        this.keepalive = keepalive;
        this._auth = _auth;
        this._router = _router;
        this.keepaliveService = keepaliveService;
        this.idleState = 'Not started.';
        this.timedOut = false;
        this.lastPing = null;
        this.DEFAULT_INACTIVITY = 3; // en minutos
        this.DEFAULT_COUNTDONW = 10; // en segundos, cuenta regresiva para cerrar la sesión
        this.DEFAULT_UNIT = 60; // unidad de conversión de min a segundos
        /**VALIDACION DE KEEP ALIVE*/
        // sets an idle timeout of 5 seconds, for testing purposes.
        idle.setIdle(!isNullOrUndefined(this.timeinactivity) ? (this.timeinactivity * this.DEFAULT_UNIT) : (this.DEFAULT_INACTIVITY * this.DEFAULT_UNIT));
        // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
        idle.setTimeout(!isNullOrUndefined(this.timecountdown) ? this.timecountdown : this.DEFAULT_COUNTDONW);
        // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
        idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
        idle.onIdleEnd.subscribe(() => {
            const element = $('.swal2-close');
            element.trigger('click');
        });
        idle.onTimeout.subscribe(() => {
            if (this._auth.isAuthenticated()) {
                this.idleState = 'Timed out!';
                this.timedOut = true;
                this._auth.logout();
                this.reset();
                swal.fire({
                    title: 'Sesión desconectada',
                    html: '<b>Para su seguridad, el sistema se desconecta automáticamente después de ' + (!isNullOrUndefined(this.timeinactivity) ? this.timeinactivity : this.DEFAULT_INACTIVITY) + ' minuto (s) de inactividad. </b>',
                });
            }
        });
        idle.onIdleStart.subscribe(() => {
            if (this._auth.isAuthenticated()) {
                const element = document.getElementById('timeoutid');
                element.click();
            }
        });
        idle.onInterrupt.subscribe(data => {
        });
        idle.onTimeoutWarning.subscribe((countdown) => {
            if (this._auth.isAuthenticated()) {
                this.idleState = '¡Tu sesión se cerrará en ' + countdown + ' segundos!';
            }
        });
        // sets the ping interval to 15 seconds
        keepalive.interval(15);
        keepalive.onPing.subscribe(() => {
            this.lastPing = new Date();
        });
        this.reset();
    }
    reset() {
        this.idle.watch();
        this.idleState = 'Started.';
        this.timedOut = false;
    }
    stay() {
        this.reset();
    }
    ngOnInit() {
        this.reset();
        this.keepaliveService.getResetObservable().subscribe((response) => {
            this.reset();
        });
        // this.keepaliveService.getUserLoggedIn().subscribe(userLoggedIn => {
        //   if (!userLoggedIn) {
        //     this.idle.stop();
        //   }
        // });
    }
    ngOnDestroy() {
        this.timedOut = true;
        this.idle.stop();
    }
}
/** @nocollapse */ KeepaliveComponent.ɵfac = function KeepaliveComponent_Factory(t) { return new (t || KeepaliveComponent)(ɵɵdirectiveInject(SwalPortalTargets), ɵɵdirectiveInject(Idle), ɵɵdirectiveInject(Keepalive), ɵɵdirectiveInject(AuthService), ɵɵdirectiveInject(Router), ɵɵdirectiveInject(KeepAliveService)); };
/** @nocollapse */ KeepaliveComponent.ɵcmp = ɵɵdefineComponent({ type: KeepaliveComponent, selectors: [["app-keepalive"]], inputs: { timeinactivity: "timeinactivity", timecountdown: "timecountdown" }, decls: 4, vars: 5, consts: [["id", "timeoutid", 3, "swal"], [3, "showCloseButton", "showConfirmButton", "showCancelButton"], ["showWindow", ""], [4, "swalPortal"], [1, "row"], [1, "col-12", "text-center"]], template: function KeepaliveComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelement(0, "a", 0);
        ɵɵelementStart(1, "swal", 1, 2);
        ɵɵtemplate(3, KeepaliveComponent_ng_container_3_Template, 10, 1, "ng-container", 3);
        ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = ɵɵreference(2);
        ɵɵproperty("swal", _r0);
        ɵɵadvance(1);
        ɵɵproperty("showCloseButton", true)("showConfirmButton", false)("showCancelButton", false);
        ɵɵadvance(2);
        ɵɵproperty("swalPortal", ctx.swalTargets.content);
    } }, directives: [SwalDirective, SwalComponent, SwalPortalDirective], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(KeepaliveComponent, [{
        type: Component,
        args: [{
                selector: 'app-keepalive',
                templateUrl: './keepalive.component.html',
                styleUrls: ['./keepalive.component.css']
            }]
    }], function () { return [{ type: SwalPortalTargets }, { type: Idle }, { type: Keepalive }, { type: AuthService }, { type: Router }, { type: KeepAliveService }]; }, { timeinactivity: [{
            type: Input
        }], timecountdown: [{
            type: Input
        }] }); })();

function CreateUserPasswordComponent_div_33_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 7);
    ɵɵpipe(1, "i18n");
} if (rf & 2) {
    const ctx_r3 = ɵɵnextContext(2);
    ɵɵproperty("innerHTML", ɵɵpipeBind2(1, 1, "@i18n-store-front-login-error-field-required", ctx_r3.lang), ɵɵsanitizeHtml);
} }
function CreateUserPasswordComponent_div_33_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 19);
    ɵɵtemplate(1, CreateUserPasswordComponent_div_33_div_1_Template, 2, 4, "div", 20);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.form.get("password").errors["required"] && !ctx_r0.form.get("password").pristine);
} }
function CreateUserPasswordComponent_div_45_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 7);
    ɵɵpipe(1, "i18n");
} if (rf & 2) {
    const ctx_r4 = ɵɵnextContext(2);
    ɵɵproperty("innerHTML", ɵɵpipeBind2(1, 1, "@i18n-store-front-login-error-field-required", ctx_r4.lang), ɵɵsanitizeHtml);
} }
function CreateUserPasswordComponent_div_45_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtext(1, " M\u00EDnimo 8 caracteres ");
    ɵɵelementEnd();
} }
function CreateUserPasswordComponent_div_45_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtext(1, " M\u00E1ximo 12 caracteres ");
    ɵɵelementEnd();
} }
function CreateUserPasswordComponent_div_45_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelement(1, "span", 7);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind2(2, 1, "@i18n-form-pattern-password", ctx_r7.lang), ɵɵsanitizeHtml);
} }
function CreateUserPasswordComponent_div_45_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtext(1, " Las contrase\u00F1as no coinciden. ");
    ɵɵelementEnd();
} }
function CreateUserPasswordComponent_div_45_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 19);
    ɵɵtemplate(1, CreateUserPasswordComponent_div_45_div_1_Template, 2, 4, "div", 20);
    ɵɵtemplate(2, CreateUserPasswordComponent_div_45_div_2_Template, 2, 0, "div", 18);
    ɵɵtemplate(3, CreateUserPasswordComponent_div_45_div_3_Template, 2, 0, "div", 18);
    ɵɵtemplate(4, CreateUserPasswordComponent_div_45_div_4_Template, 3, 4, "div", 18);
    ɵɵtemplate(5, CreateUserPasswordComponent_div_45_div_5_Template, 2, 0, "div", 18);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r1.form.get("password2").errors["required"] && !ctx_r1.form.get("password").pristine);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r1.form.get("password2").hasError("minlength") && !ctx_r1.form.get("password").pristine);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r1.form.get("password2").hasError("maxlength") && !ctx_r1.form.get("password").pristine);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r1.form.get("password2").hasError("pattern") && !ctx_r1.form.get("password").pristine);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r1.form.get("password2").hasError("passwordDistinct") && !ctx_r1.form.get("password").pristine);
} }
function CreateUserPasswordComponent_span_50_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span");
    ɵɵelement(1, "i", 21);
    ɵɵelementEnd();
} }
const _c0$1 = function (a0) { return { "error": a0 }; };
const _c1$1 = function (a0, a1) { return { " fa-eye": a0, "fa-eye-slash": a1 }; };
class CreateUserPasswordComponent {
    constructor(_activatedRoute, _router, formBuilder, _i18n, _auth, _httpService, _error, localStorage) {
        this._activatedRoute = _activatedRoute;
        this._router = _router;
        this.formBuilder = formBuilder;
        this._i18n = _i18n;
        this._auth = _auth;
        this._httpService = _httpService;
        this._error = _error;
        this.localStorage = localStorage;
        this.response = new EventEmitter();
        this.submit_disabled = false;
        this.regxpassword = "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,12}$)(?=.*\\W)(?!.*(.)\\1\\1\\1).*$";
        this.typeInputPass = false;
        this.typeInputPass2 = false;
        this.rule1 = "";
        this.rule2 = "";
        this.rule3 = "";
        this.rule4 = "";
        this.rule5 = "";
        this.validatePatternsRules = (evaluar) => {
            if (evaluar.length >= 8 && evaluar.length <= 12) {
                this.rule1 = 'check-';
            }
            else {
                this.rule1 = '';
            }
            if (this.validateExistsNumber(evaluar)) {
                this.rule2 = 'check-';
            }
            else {
                this.rule2 = '';
            }
            if (this.validateUpperAndLowerLetter(evaluar)) {
                this.rule3 = 'check-';
            }
            else {
                this.rule3 = '';
            }
            if (this.validateSpecialCharacters(evaluar)) {
                this.rule4 = 'check-';
            }
            else {
                this.rule4 = '';
            }
            if (this.validateConsecutive(evaluar)) {
                this.rule5 = 'check-';
            }
            else {
                this.rule5 = '';
            }
        };
        this.validateExistsNumber = (input_value) => {
            return ((input_value.replace(/[^0-9]/g, "").length == 0) ? false : true);
        };
        this.validateUpperAndLowerLetter = (input_value) => {
            return ((input_value.replace(/[^A-Z]/g, "").length == 0) || (input_value.replace(/[^a-z]/g, "").length == 0) ? false : true);
        };
        this.validateSpecialCharacters = (input_value) => {
            return ((input_value.toLowerCase().replace(/[^!@#$%^&*()+={}/|:;<>,.?-_]/g, "").length == 0) ? false : true);
        };
        this.validateConsecutive = (input_value) => {
            return (/^(?!.*([A-Za-z0-9!@#$%^&*()+={}/|:;<>,.?-_\s])\1{3})[A-Za-z!@#$%^&*()+={}/|:;<>,.?-_\s0-9]+$/.test(input_value)) ? true : false;
        };
    }
    viewPassword() {
        this.typeInputPass = !(this.typeInputPass);
    }
    viewPassword2() {
        this.typeInputPass2 = !(this.typeInputPass2);
    }
    ngOnInit() {
        if (this.token) {
            this._httpService.executeRequest(this.config.validation.url, this.config.validation.params).subscribe((data) => {
                this.submit_disabled = false;
                if (data) {
                    swal.fire({
                        title: '',
                        html: 'El link ingresado ya fue utilizado,  por favor ingrese su usuario y contraseña.'
                    });
                    this.response.emit({
                        response: null,
                        type: 'VALIDATION_LINK_FAIL',
                        success: false
                    });
                }
            }, (error) => {
                this.submit_disabled = false;
                this.response.emit({
                    response: null,
                    type: 'VALIDATION_FAIL',
                    success: false
                });
            });
        }
        this.form = this.formBuilder.group({
            password: ['', [Validators.required, , Validators.minLength(8), Validators.maxLength(12), Validators.pattern(this.regxpassword)]],
            password2: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(12)]]
        }, { validator: this.mustMatch('password', 'password2') });
    }
    updateValueAndValidity() {
        let controlField = this.form.controls['password2'];
        controlField.updateValueAndValidity();
    }
    mustMatch(controlName, matchingControlName) {
        return (formGroup) => {
            const control = formGroup.controls[controlName];
            this.validatePatternsRules(control.value);
            const matchingControl = formGroup.controls[matchingControlName];
            if (matchingControl.errors && !matchingControl.errors.mustMatch) {
                // return if another validator has already found an error on the matchingControl
                return;
            }
            // set error on matchingControl if validation fails
            if (control.value !== matchingControl.value) {
                matchingControl.setErrors({ passwordDistinct: true });
            }
            else {
                matchingControl.setErrors(null);
            }
        };
    }
    submit() {
        this.submit_disabled = true;
        if (this.form.dirty && this.form.valid) {
            if (this.form.get('password').value === this.form.get('password2').value) {
                if (this.username) {
                    const password_encrypt = this._auth.encryptPassword(this.form.get('password').value);
                    const confirmpassword_encrypt = this._auth.encryptPassword(this.form.get('password2').value);
                    const data = {
                        'identifier': this.username,
                        'password': password_encrypt,
                        'confirmPassword': confirmpassword_encrypt,
                        'name': this.token
                    };
                    this.config.save.params.body = data;
                    this.config.save.params.responseType = 'text';
                    const url = this.localStorage.getItem('modeUpdatePass') === 'true' ? this.config.update.url : this.config.save.url;
                    this._httpService.executeRequest(url, this.config.save.params).subscribe((res) => {
                        this.submit_disabled = false;
                        // Mario: Lo comente porque este mensaje es mejor mostrarlo desde la app, por el tema de que da un mensaje que no funciona para los dos casos que se utilizan
                        // if (this.token || res.token) {
                        //   swal.fire({
                        //     title: 'Exito',
                        //     html: 'El link ingresado ya fue utilizado,  por favor ingrese su usuario y contraseña.'
                        //   });
                        // }
                        if (res.token) {
                            this._auth.setSession(res);
                        }
                        this.response.emit({
                            response: res,
                            type: null,
                            success: true
                        });
                    }, err => {
                        console.log('El error:');
                        this.submit_disabled = false;
                        let errs = JSON.parse(((err === null || err === void 0 ? void 0 : err.error) || "{}"));
                        this._error.show({
                            response: null,
                            type: '400',
                            success: false
                        }, ' ', this._i18n.transform(errs === null || errs === void 0 ? void 0 : errs.message));
                        this.response.emit({
                            response: null,
                            type: '400',
                            success: false
                        });
                        this.submit_disabled = false;
                    });
                }
                else {
                    this.submit_disabled = false;
                    swal.fire({
                        title: 'Error',
                        html: '<b>La URL no existe</b><br>Por favor, intente de nuevo'
                    });
                    this.response.emit({
                        response: null,
                        type: 'VALIDATION_LINK_NOT_FOUND',
                        success: false
                    });
                }
                this.submit_disabled = false;
            }
            else {
                this.form.get('password').setValue('');
                this.form.get('password').patchValue('');
                this.submit_disabled = false;
                swal.fire({
                    title: 'Error',
                    html: '<b>La contraseña y su confirmación no coinciden</b>',
                });
            }
        }
        else {
            this.submit_disabled = false;
            swal.fire({
                title: 'Error',
                html: '<b>Por favor, ingrese los campos requeridos</b>',
            });
        }
    }
    ngOnDestroy() {
    }
}
/** @nocollapse */ CreateUserPasswordComponent.ɵfac = function CreateUserPasswordComponent_Factory(t) { return new (t || CreateUserPasswordComponent)(ɵɵdirectiveInject(ActivatedRoute), ɵɵdirectiveInject(Router), ɵɵdirectiveInject(FormBuilder), ɵɵdirectiveInject(I18nPipe), ɵɵdirectiveInject(AuthService), ɵɵdirectiveInject(HttpService), ɵɵdirectiveInject(ErrorService$1), ɵɵdirectiveInject(LocalService)); };
/** @nocollapse */ CreateUserPasswordComponent.ɵcmp = ɵɵdefineComponent({ type: CreateUserPasswordComponent, selectors: [["akeela-auth-create-user-password"]], inputs: { username: "username", config: "config", token: "token" }, outputs: { response: "response" }, decls: 51, vars: 75, consts: [[1, "container-fluid", "main-content", "animated", "fadeIn"], [1, "bg-light", "text-dark", "box"], [1, "title", "text-center", "font-weight-light"], ["novalidate", "", "autocomplete", "current-password", 3, "formGroup", "ngSubmit"], [1, "row"], [1, "col-12", "form-group"], [1, "label", "font-weight-normal", 2, "word-wrap", "break-word"], [3, "innerHTML"], [1, "text-danger", "mt-1"], [1, "input-group"], ["autocomplete", "current-password", "formControlName", "password", 1, "form-control", 3, "placeholder", "type", "ngClass", "keyup"], [1, "input-group-append"], [1, "pt-2", "far", "cursor-pounter", "input-group-text", 3, "ngClass", "click"], [1, "row", "pt-2", "small"], [1, "col-12"], ["class", "form-control-feedback help-block", 4, "ngIf"], ["autocomplete", "current-password", "autocomplete", "off", "formControlName", "password2", 1, "form-control", 3, "placeholder", "type", "ngClass"], ["type", "submit", 1, "btn", "btn-block", "btn-primary", "btn-lg", 3, "disabled"], [4, "ngIf"], [1, "form-control-feedback", "help-block"], [3, "innerHTML", 4, "ngIf"], [1, "fa", "fa-spinner", "fa-spin"]], template: function CreateUserPasswordComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelementStart(2, "h2", 2);
        ɵɵtext(3, "Crear contrase\u00F1a de usuario");
        ɵɵelementEnd();
        ɵɵelementStart(4, "form", 3);
        ɵɵlistener("ngSubmit", function CreateUserPasswordComponent_Template_form_ngSubmit_4_listener() { return ctx.submit(); });
        ɵɵelementStart(5, "div", 4);
        ɵɵelementStart(6, "div", 5);
        ɵɵelementStart(7, "label", 6);
        ɵɵelement(8, "span", 7);
        ɵɵpipe(9, "i18n");
        ɵɵelementStart(10, "span", 8);
        ɵɵtext(11, " * ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(12, "div", 9);
        ɵɵelementStart(13, "input", 10);
        ɵɵlistener("keyup", function CreateUserPasswordComponent_Template_input_keyup_13_listener() { return ctx.updateValueAndValidity(); });
        ɵɵpipe(14, "i18n");
        ɵɵelementEnd();
        ɵɵelementStart(15, "div", 11);
        ɵɵelementStart(16, "i", 12);
        ɵɵlistener("click", function CreateUserPasswordComponent_Template_i_click_16_listener() { return ctx.viewPassword(); });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(17, "div", 13);
        ɵɵelementStart(18, "div", 14);
        ɵɵelement(19, "i");
        ɵɵtext(20, " Entre 8 y 12 car\u00E1cteres. ");
        ɵɵelementEnd();
        ɵɵelementStart(21, "div", 14);
        ɵɵelement(22, "i");
        ɵɵtext(23, " Debe contener n\u00FAmeros. ");
        ɵɵelementEnd();
        ɵɵelementStart(24, "div", 14);
        ɵɵelement(25, "i");
        ɵɵtext(26, " Debe contener letr\u00E1s may\u00FAsculas y min\u00FAsculas. ");
        ɵɵelementEnd();
        ɵɵelementStart(27, "div", 14);
        ɵɵelement(28, "i");
        ɵɵtext(29, " Debe contener car\u00E1cteres especiales. ");
        ɵɵelementEnd();
        ɵɵelementStart(30, "div", 14);
        ɵɵelement(31, "i");
        ɵɵtext(32, " No debe contener: M\u00E1s de 3 caracteres consecutivos iguales (alfab\u00E9ticos, num\u00E9ricos o especiales). ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵtemplate(33, CreateUserPasswordComponent_div_33_Template, 2, 1, "div", 15);
        ɵɵelementEnd();
        ɵɵelementStart(34, "div", 5);
        ɵɵelementStart(35, "label", 6);
        ɵɵelement(36, "span", 7);
        ɵɵpipe(37, "i18n");
        ɵɵelementStart(38, "span", 8);
        ɵɵtext(39, " * ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(40, "div", 9);
        ɵɵelement(41, "input", 16);
        ɵɵpipe(42, "i18n");
        ɵɵelementStart(43, "div", 11);
        ɵɵelementStart(44, "i", 12);
        ɵɵlistener("click", function CreateUserPasswordComponent_Template_i_click_44_listener() { return ctx.viewPassword2(); });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵtemplate(45, CreateUserPasswordComponent_div_45_Template, 6, 5, "div", 15);
        ɵɵelementEnd();
        ɵɵelement(46, "br");
        ɵɵelementStart(47, "button", 17);
        ɵɵelement(48, "span", 7);
        ɵɵpipe(49, "i18n");
        ɵɵtemplate(50, CreateUserPasswordComponent_span_50_Template, 2, 0, "span", 18);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(4);
        ɵɵproperty("formGroup", ctx.form);
        ɵɵadvance(4);
        ɵɵproperty("innerHTML", ɵɵpipeBind2(9, 51, "@i18n-store-front-login-form-password", ctx.lang), ɵɵsanitizeHtml);
        ɵɵadvance(5);
        ɵɵproperty("placeholder", ɵɵpipeBind2(14, 54, "@i18n-store-front-login-form-password", ctx.lang))("type", !ctx.typeInputPass ? "password" : "text")("ngClass", ɵɵpureFunction1(65, _c0$1, ctx.form.controls.password.invalid && ctx.form.controls.password.dirty));
        ɵɵadvance(3);
        ɵɵproperty("ngClass", ɵɵpureFunction2(67, _c1$1, ctx.typeInputPass, !ctx.typeInputPass));
        ɵɵadvance(3);
        ɵɵclassMapInterpolate1("fas fa-", ctx.rule1, "circle");
        ɵɵclassProp("checked", ctx.rule1 === "check-")("uncheck", ctx.rule1 === "");
        ɵɵadvance(3);
        ɵɵclassMapInterpolate1("fas fa-", ctx.rule2, "circle");
        ɵɵclassProp("checked", ctx.rule2 === "check-")("uncheck", ctx.rule2 === "");
        ɵɵadvance(3);
        ɵɵclassMapInterpolate1("fas fa-", ctx.rule3, "circle");
        ɵɵclassProp("checked", ctx.rule3 === "check-")("uncheck", ctx.rule3 === "");
        ɵɵadvance(3);
        ɵɵclassMapInterpolate1("fas fa-", ctx.rule4, "circle");
        ɵɵclassProp("checked", ctx.rule4 === "check-")("uncheck", ctx.rule4 === "");
        ɵɵadvance(3);
        ɵɵclassMapInterpolate1("fas fa-", ctx.rule5, "circle");
        ɵɵclassProp("checked", ctx.rule5 === "check-")("uncheck", ctx.rule5 === "");
        ɵɵadvance(2);
        ɵɵproperty("ngIf", ctx.form.get("password").errors);
        ɵɵadvance(3);
        ɵɵproperty("innerHTML", ɵɵpipeBind2(37, 57, "@i18n-store-front-login-form-confirmPassword", ctx.lang), ɵɵsanitizeHtml);
        ɵɵadvance(5);
        ɵɵproperty("placeholder", ɵɵpipeBind2(42, 60, "@i18n-quote-createUser-form-label-confirmPassword", ctx.lang))("type", !ctx.typeInputPass2 ? "password" : "text")("ngClass", ɵɵpureFunction1(70, _c0$1, ctx.form.controls.password2.invalid && ctx.form.controls.password2.dirty));
        ɵɵadvance(3);
        ɵɵproperty("ngClass", ɵɵpureFunction2(72, _c1$1, ctx.typeInputPass2, !ctx.typeInputPass2));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.form.get("password2").errors);
        ɵɵadvance(2);
        ɵɵproperty("disabled", !ctx.form.valid || ctx.submit_disabled);
        ɵɵadvance(1);
        ɵɵproperty("innerHTML", ɵɵpipeBind1(49, 63, "@i18n-text-button-send"), ɵɵsanitizeHtml);
        ɵɵadvance(2);
        ɵɵproperty("ngIf", ctx.submit_disabled);
    } }, directives: [ɵangular_packages_forms_forms_y, NgControlStatusGroup, FormGroupDirective, DefaultValueAccessor, NgControlStatus, FormControlName, NgClass, NgIf], pipes: [I18nPipe], styles: [".box[_ngcontent-%COMP%]{box-shadow:0 2px 4px 0 hsla(0,0%,60%,.5);margin-left:auto;margin-right:auto;margin-top:2rem;padding:3rem 1.5rem;width:25rem}.box[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{margin-bottom:2.5rem}@media (max-width:26.875rem){.box[_ngcontent-%COMP%]{width:100%}}.link[_ngcontent-%COMP%]{font-size:.875rem}.ls[_ngcontent-%COMP%]{letter-spacing:-2px}.ls-o[_ngcontent-%COMP%]{color:#777}.cursor-pounter[_ngcontent-%COMP%]{cursor:pointer}.uncheck[_ngcontent-%COMP%]{color:#e1e0e0}.checked[_ngcontent-%COMP%]{color:#4a9961}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CreateUserPasswordComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-auth-create-user-password',
                templateUrl: './create-user-password.component.html',
                styleUrls: ['./create-user-password.component.css']
            }]
    }], function () { return [{ type: ActivatedRoute }, { type: Router }, { type: FormBuilder }, { type: I18nPipe }, { type: AuthService }, { type: HttpService }, { type: ErrorService$1 }, { type: LocalService }]; }, { username: [{
            type: Input
        }], config: [{
            type: Input
        }], token: [{
            type: Input
        }], response: [{
            type: Output
        }] }); })();

function RecoveryPasswordComponent_div_14_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 7);
    ɵɵpipe(1, "i18n");
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext(2);
    ɵɵproperty("innerHTML", ɵɵpipeBind2(1, 1, "@i18n-store-front-login-error-field-required", ctx_r2.lang), ɵɵsanitizeHtml);
} }
function RecoveryPasswordComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 13);
    ɵɵtemplate(1, RecoveryPasswordComponent_div_14_div_1_Template, 2, 4, "div", 14);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.form.get("username").errors["required"] && !ctx_r0.form.get("username").pristine);
} }
function RecoveryPasswordComponent_ng_container_18_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainer(0);
} }
const _c0$2 = function (a0) { return { "error": a0 }; };
class RecoveryPasswordComponent {
    constructor(templateService, formBuilder, _httpService) {
        this.templateService = templateService;
        this.formBuilder = formBuilder;
        this._httpService = _httpService;
        this.response = new EventEmitter();
        this.templates = {};
        this.submit_disabled = false;
    }
    ngOnInit() {
        this.form = this.formBuilder.group({
            username: ['', Validators.required]
        });
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.templates = this.templateService.getTemplates();
        }, 1);
    }
    submit() {
        if (this.form.dirty && this.form.valid) {
            this.submit_disabled = true;
            this.config.params.body = {
                identifier: this.form.get('username').value
            };
            this._httpService.executeRequest(this.config.url, this.config.params, true).subscribe((data) => {
                this.submit_disabled = false;
                this.response.emit({
                    response: data,
                    success: true
                });
            }, (error) => {
                this.submit_disabled = false;
                this.form.reset();
                this.response.emit({
                    response: error,
                    success: false
                });
            });
        }
    }
}
/** @nocollapse */ RecoveryPasswordComponent.ɵfac = function RecoveryPasswordComponent_Factory(t) { return new (t || RecoveryPasswordComponent)(ɵɵdirectiveInject(AkeelaTemplateService), ɵɵdirectiveInject(FormBuilder), ɵɵdirectiveInject(HttpService)); };
/** @nocollapse */ RecoveryPasswordComponent.ɵcmp = ɵɵdefineComponent({ type: RecoveryPasswordComponent, selectors: [["akeela-auth-recovery-password"]], inputs: { config: "config" }, outputs: { response: "response" }, decls: 19, vars: 20, consts: [[1, "container-fluid", "main-content", "animated", "fadeIn"], [1, "teme-gray", "box"], [1, "title", "text-center", "font-weight-light", 3, "innerHTML"], ["novalidate", "", 1, "text-left", 3, "formGroup", "ngSubmit"], [1, ""], [1, "form-group"], [1, "label", "font-weight-normal", 2, "word-wrap", "break-word"], [3, "innerHTML"], [1, "text-danger", "mt-1"], ["type", "text", "formControlName", "username", 1, "form-control", 3, "ngClass", "placeholder"], ["class", "form-control-feedback help-block", 4, "ngIf"], ["type", "submit", 1, "btn", "btn-block", "btn-primary", 3, "disabled", "innerHTML"], [4, "ngTemplateOutlet"], [1, "form-control-feedback", "help-block"], [3, "innerHTML", 4, "ngIf"]], template: function RecoveryPasswordComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelement(2, "h2", 2);
        ɵɵpipe(3, "i18n");
        ɵɵelementStart(4, "form", 3);
        ɵɵlistener("ngSubmit", function RecoveryPasswordComponent_Template_form_ngSubmit_4_listener() { return ctx.submit(); });
        ɵɵelementStart(5, "div", 4);
        ɵɵelementStart(6, "div", 5);
        ɵɵelementStart(7, "label", 6);
        ɵɵelement(8, "span", 7);
        ɵɵpipe(9, "i18n");
        ɵɵelementStart(10, "span", 8);
        ɵɵtext(11, " * ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelement(12, "input", 9);
        ɵɵpipe(13, "i18n");
        ɵɵtemplate(14, RecoveryPasswordComponent_div_14_Template, 2, 1, "div", 10);
        ɵɵelementEnd();
        ɵɵelement(15, "button", 11);
        ɵɵpipe(16, "i18n");
        ɵɵelement(17, "br");
        ɵɵtemplate(18, RecoveryPasswordComponent_ng_container_18_Template, 1, 0, "ng-container", 12);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(2);
        ɵɵproperty("innerHTML", ɵɵpipeBind1(3, 9, "@i18n-text-recovery-password"), ɵɵsanitizeHtml);
        ɵɵadvance(2);
        ɵɵproperty("formGroup", ctx.form);
        ɵɵadvance(4);
        ɵɵproperty("innerHTML", ɵɵpipeBind2(9, 11, "@i18n-store-front-login-form-username", ctx.lang), ɵɵsanitizeHtml);
        ɵɵadvance(4);
        ɵɵproperty("ngClass", ɵɵpureFunction1(18, _c0$2, ctx.form.controls.username.invalid && ctx.form.controls.username.dirty))("placeholder", ɵɵpipeBind1(13, 14, "@i18n-store-front-login-form-input-username-placeholder"));
        ɵɵadvance(2);
        ɵɵproperty("ngIf", ctx.form.get("username").errors);
        ɵɵadvance(1);
        ɵɵproperty("disabled", !ctx.form.valid || ctx.submit_disabled)("innerHTML", ɵɵpipeBind1(16, 16, "@i18n-text-button-send"), ɵɵsanitizeHtml);
        ɵɵadvance(3);
        ɵɵproperty("ngTemplateOutlet", ctx.templates["login-links-recovery-password"]);
    } }, directives: [ɵangular_packages_forms_forms_y, NgControlStatusGroup, FormGroupDirective, DefaultValueAccessor, NgControlStatus, FormControlName, NgClass, NgIf, NgTemplateOutlet], pipes: [I18nPipe], styles: [".box[_ngcontent-%COMP%]{box-shadow:0 2px 4px 0 hsla(0,0%,60%,.5);margin-left:auto;margin-right:auto;margin-top:2rem;padding:3rem 1.5rem;width:25rem}.box[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{margin-bottom:2.5rem}@media (max-width:25.875rem){.box[_ngcontent-%COMP%]{width:100%}}.label2[_ngcontent-%COMP%]{font-size:.7rem;margin-top:.3rem}.link[_ngcontent-%COMP%]{font-size:.875rem}.ls[_ngcontent-%COMP%]{letter-spacing:-2px}.ls-o[_ngcontent-%COMP%]{color:#777}.help-block[_ngcontent-%COMP%]{line-height:1rem}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(RecoveryPasswordComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-auth-recovery-password',
                templateUrl: './recovery-password.component.html',
                styleUrls: ['./recovery-password.component.css']
            }]
    }], function () { return [{ type: AkeelaTemplateService }, { type: FormBuilder }, { type: HttpService }]; }, { config: [{
            type: Input
        }], response: [{
            type: Output
        }] }); })();

function ChangePasswordComponent_div_44_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 7);
    ɵɵpipe(1, "i18n");
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext(2);
    ɵɵproperty("innerHTML", ɵɵpipeBind2(1, 1, "@i18n-store-front-login-error-field-required", ctx_r2.lang), ɵɵsanitizeHtml);
} }
function ChangePasswordComponent_div_44_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtext(1, " M\u00EDnimo 8 caracteres ");
    ɵɵelementEnd();
} }
function ChangePasswordComponent_div_44_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtext(1, " M\u00E1ximo 12 caracteres ");
    ɵɵelementEnd();
} }
function ChangePasswordComponent_div_44_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelement(1, "span", 7);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind2(2, 1, "@i18n-form-pattern-password", ctx_r5.lang), ɵɵsanitizeHtml);
} }
function ChangePasswordComponent_div_44_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtext(1, " Las contrase\u00F1as no coinciden. ");
    ɵɵelementEnd();
} }
function ChangePasswordComponent_div_44_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 21);
    ɵɵtemplate(1, ChangePasswordComponent_div_44_div_1_Template, 2, 4, "div", 22);
    ɵɵtemplate(2, ChangePasswordComponent_div_44_div_2_Template, 2, 0, "div", 20);
    ɵɵtemplate(3, ChangePasswordComponent_div_44_div_3_Template, 2, 0, "div", 20);
    ɵɵtemplate(4, ChangePasswordComponent_div_44_div_4_Template, 3, 4, "div", 20);
    ɵɵtemplate(5, ChangePasswordComponent_div_44_div_5_Template, 2, 0, "div", 20);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.form.get("password2").errors["required"] && !ctx_r0.form.get("password").pristine);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.form.get("password2").hasError("minlength") && !ctx_r0.form.get("password").pristine);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.form.get("password2").hasError("maxlength") && !ctx_r0.form.get("password").pristine);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.form.get("password2").hasError("pattern") && !ctx_r0.form.get("password").pristine);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.form.get("password2").hasError("passwordDistinct") && !ctx_r0.form.get("password").pristine);
} }
function ChangePasswordComponent_span_52_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span");
    ɵɵelement(1, "i", 23);
    ɵɵelementEnd();
} }
const _c0$3 = function (a0) { return { "error": a0 }; };
const _c1$2 = function (a0, a1) { return { " fa-eye": a0, "fa-eye-slash": a1 }; };
class ChangePasswordComponent {
    constructor(_activatedRoute, _router, formBuilder, _i18n, _auth, _httpService, _error, localStorage) {
        this._activatedRoute = _activatedRoute;
        this._router = _router;
        this.formBuilder = formBuilder;
        this._i18n = _i18n;
        this._auth = _auth;
        this._httpService = _httpService;
        this._error = _error;
        this.localStorage = localStorage;
        this.response = new EventEmitter();
        this.submit_disabled = false;
        this.regxpassword = "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,12}$)(?=.*\\W)(?!.*(.)\\1\\1\\1).*$";
        this.typeInputPass = false;
        this.typeInputPass2 = false;
        this.rule1 = "";
        this.rule2 = "";
        this.rule3 = "";
        this.rule4 = "";
        this.rule5 = "";
        this.validatePatternsRules = (evaluar) => {
            if (evaluar.length >= 8 && evaluar.length <= 12) {
                this.rule1 = 'check-';
            }
            else {
                this.rule1 = '';
            }
            if (this.validateExistsNumber(evaluar)) {
                this.rule2 = 'check-';
            }
            else {
                this.rule2 = '';
            }
            if (this.validateUpperAndLowerLetter(evaluar)) {
                this.rule3 = 'check-';
            }
            else {
                this.rule3 = '';
            }
            if (this.validateSpecialCharacters(evaluar)) {
                this.rule4 = 'check-';
            }
            else {
                this.rule4 = '';
            }
            if (this.validateConsecutive(evaluar)) {
                this.rule5 = 'check-';
            }
            else {
                this.rule5 = '';
            }
        };
        this.validateExistsNumber = (input_value) => {
            return ((input_value.replace(/[^0-9]/g, "").length == 0) ? false : true);
        };
        this.validateUpperAndLowerLetter = (input_value) => {
            return ((input_value.replace(/[^A-Z]/g, "").length == 0) || (input_value.replace(/[^a-z]/g, "").length == 0) ? false : true);
        };
        this.validateSpecialCharacters = (input_value) => {
            return ((input_value.toLowerCase().replace(/[^!@#$%^&*()+={}/|:;<>,.?-_]/g, "").length == 0) ? false : true);
        };
        this.validateConsecutive = (input_value) => {
            return (/^(?!.*([A-Za-z0-9!@#$%^&*()+={}/|:;<>,.?-_\s])\1{3})[A-Za-z!@#$%^&*()+={}/|:;<>,.?-_\s0-9]+$/.test(input_value)) ? true : false;
        };
    }
    ngOnInit() {
        this.form = this.formBuilder.group({
            password: ['', [Validators.required, , Validators.minLength(8), Validators.maxLength(12), Validators.pattern(this.regxpassword)]],
            password2: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(12)]]
        }, { validator: this.mustMatch('password', 'password2') });
    }
    updateValueAndValidity() {
        let controlField = this.form.controls['password2'];
        controlField.updateValueAndValidity();
    }
    mustMatch(controlName, matchingControlName) {
        return (formGroup) => {
            const control = formGroup.controls[controlName];
            this.validatePatternsRules(control.value);
            const matchingControl = formGroup.controls[matchingControlName];
            if (matchingControl.errors && !matchingControl.errors.mustMatch) {
                // return if another validator has already found an error on the matchingControl
                return;
            }
            // set error on matchingControl if validation fails
            if (control.value !== matchingControl.value) {
                matchingControl.setErrors({ passwordDistinct: true });
            }
            else {
                matchingControl.setErrors(null);
            }
        };
    }
    submit() {
        this.submit_disabled = true;
        if (this.form.dirty && this.form.valid) {
            if (this.form.get('password').value === this.form.get('password2').value) {
                // reset el password 
                const pre_data = {
                    'identifier': this._auth.isAuthenticated() ? this._auth.getUsername() : this.localStorage.getItem('modeUpdatePass')
                };
                this.config.reset.params.body = pre_data;
                this._httpService.executeRequest(this.config.reset.url, this.config.reset.params).subscribe((resp) => {
                    // colocar el password nuevo
                    const password_encrypt = this._auth.encryptPassword(this.form.get('password').value);
                    const confirmpassword_encrypt = this._auth.encryptPassword(this.form.get('password2').value);
                    const data = {
                        'identifier': this._auth.getUsername(),
                        'password': password_encrypt,
                        'confirmPassword': confirmpassword_encrypt,
                        'name': resp.name
                    };
                    this.config.save.params.body = data;
                    this._httpService.executeRequest(this.config.save.url, this.config.save.params).subscribe((res) => {
                        this.submit_disabled = false;
                        //this.form.reset();
                        this.response.emit({
                            response: res,
                            type: null,
                            success: true
                        });
                    }, err => {
                        this.submit_disabled = false;
                        //this.form.reset();
                        this._error.show(err.error);
                        this.response.emit({
                            response: null,
                            type: '500',
                            success: false
                        });
                    });
                }, err => {
                    this.submit_disabled = false;
                    this._error.show(err.error);
                    this.response.emit({
                        response: null,
                        type: '500',
                        success: false
                    });
                });
            }
            else {
                this.form.get('password').setValue('');
                this.form.get('password').patchValue('');
                this.submit_disabled = false;
                swal.fire({
                    title: 'Error',
                    html: '<b>La contraseña y su confirmación no coinciden</b>',
                });
            }
        }
        else {
            this.submit_disabled = false;
            swal.fire({
                title: 'Error',
                html: '<b>Por favor, ingrese los campos requeridos</b>',
            });
        }
    }
    viewPassword() {
        this.typeInputPass = !(this.typeInputPass);
    }
    viewPassword2() {
        this.typeInputPass2 = !(this.typeInputPass2);
    }
}
/** @nocollapse */ ChangePasswordComponent.ɵfac = function ChangePasswordComponent_Factory(t) { return new (t || ChangePasswordComponent)(ɵɵdirectiveInject(ActivatedRoute), ɵɵdirectiveInject(Router), ɵɵdirectiveInject(FormBuilder), ɵɵdirectiveInject(I18nPipe), ɵɵdirectiveInject(AuthService), ɵɵdirectiveInject(HttpService), ɵɵdirectiveInject(ErrorService$1), ɵɵdirectiveInject(LocalService)); };
/** @nocollapse */ ChangePasswordComponent.ɵcmp = ɵɵdefineComponent({ type: ChangePasswordComponent, selectors: [["akeela-change-user-password"]], inputs: { username: "username", config: "config", token: "token" }, outputs: { response: "response" }, decls: 53, vars: 71, consts: [[1, "container", "animated", "fadeIn"], [1, "box-head", "skin-white"], [1, "mt-2", "mb-3", "text-size-1"], [3, "formGroup", "ngSubmit"], [1, "row", "form-group"], [1, "col-md-4", "col-12", "text-left"], [1, "label", "font-weight-normal", 2, "word-wrap", "break-word"], [3, "innerHTML"], [1, "text-danger", "mt-1"], [1, "input-group"], ["autocomplete", "current-password", "formControlName", "password", 1, "form-control", 3, "placeholder", "type", "ngClass", "keyup"], [1, "input-group-append"], [1, "pt-2", "far", "cursor-pounter", "input-group-text", 3, "ngClass", "click"], [1, "row", "pt-2", "small"], [1, "col-12"], ["autocomplete", "current-password", "formControlName", "password2", 1, "form-control", 3, "placeholder", "type", "ngClass"], ["class", "form-control-feedback help-block", 4, "ngIf"], [1, "row"], [1, "col-lg-4", "offset-8", "text-left", "form-group"], ["type", "submit ", 1, "btn", "btn-block", "btn-primary", "btn-md", 3, "disabled"], [4, "ngIf"], [1, "form-control-feedback", "help-block"], [3, "innerHTML", 4, "ngIf"], [1, "fa", "fa-refresh", "fa-spin"]], template: function ChangePasswordComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelementStart(2, "div", 2);
        ɵɵtext(3, "Cambiar Contrase\u00F1a");
        ɵɵelementEnd();
        ɵɵelementStart(4, "form", 3);
        ɵɵlistener("ngSubmit", function ChangePasswordComponent_Template_form_ngSubmit_4_listener() { return ctx.submit(); });
        ɵɵelementStart(5, "div", 4);
        ɵɵelementStart(6, "div", 5);
        ɵɵelementStart(7, "label", 6);
        ɵɵelement(8, "span", 7);
        ɵɵpipe(9, "i18n");
        ɵɵelementStart(10, "span", 8);
        ɵɵtext(11, " * ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(12, "div", 9);
        ɵɵelementStart(13, "input", 10);
        ɵɵlistener("keyup", function ChangePasswordComponent_Template_input_keyup_13_listener() { return ctx.updateValueAndValidity(); });
        ɵɵpipe(14, "i18n");
        ɵɵelementEnd();
        ɵɵelementStart(15, "div", 11);
        ɵɵelementStart(16, "i", 12);
        ɵɵlistener("click", function ChangePasswordComponent_Template_i_click_16_listener() { return ctx.viewPassword(); });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(17, "div", 13);
        ɵɵelementStart(18, "div", 14);
        ɵɵelement(19, "i");
        ɵɵtext(20, " Entre 8 y 12 car\u00E1cteres. ");
        ɵɵelementEnd();
        ɵɵelementStart(21, "div", 14);
        ɵɵelement(22, "i");
        ɵɵtext(23, " Debe contener n\u00FAmeros. ");
        ɵɵelementEnd();
        ɵɵelementStart(24, "div", 14);
        ɵɵelement(25, "i");
        ɵɵtext(26, " Debe contener letr\u00E1s may\u00FAsculas y min\u00FAsculas. ");
        ɵɵelementEnd();
        ɵɵelementStart(27, "div", 14);
        ɵɵelement(28, "i");
        ɵɵtext(29, " Debe contener car\u00E1cteres especiales. ");
        ɵɵelementEnd();
        ɵɵelementStart(30, "div", 14);
        ɵɵelement(31, "i");
        ɵɵtext(32, " No debe contener: M\u00E1s de 3 caracteres consecutivos iguales (alfab\u00E9ticos, num\u00E9ricos o especiales). ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(33, "div", 5);
        ɵɵelementStart(34, "label", 6);
        ɵɵelement(35, "span", 7);
        ɵɵpipe(36, "i18n");
        ɵɵelementStart(37, "span", 8);
        ɵɵtext(38, " * ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(39, "div", 9);
        ɵɵelement(40, "input", 15);
        ɵɵpipe(41, "i18n");
        ɵɵelementStart(42, "div", 11);
        ɵɵelementStart(43, "i", 12);
        ɵɵlistener("click", function ChangePasswordComponent_Template_i_click_43_listener() { return ctx.viewPassword2(); });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵtemplate(44, ChangePasswordComponent_div_44_Template, 6, 5, "div", 16);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(45, "div", 17);
        ɵɵelementStart(46, "div", 18);
        ɵɵelement(47, "br");
        ɵɵelementStart(48, "button", 19);
        ɵɵelementStart(49, "span");
        ɵɵtext(50, "Guardar");
        ɵɵelementEnd();
        ɵɵtext(51, "\u00A0 ");
        ɵɵtemplate(52, ChangePasswordComponent_span_52_Template, 2, 0, "span", 20);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(4);
        ɵɵproperty("formGroup", ctx.form);
        ɵɵadvance(4);
        ɵɵproperty("innerHTML", ɵɵpipeBind2(9, 49, "@i18n-store-front-login-form-password", ctx.lang), ɵɵsanitizeHtml);
        ɵɵadvance(5);
        ɵɵproperty("placeholder", ɵɵpipeBind2(14, 52, "@i18n-store-front-login-form-password", ctx.lang))("type", !ctx.typeInputPass ? "password" : "text")("ngClass", ɵɵpureFunction1(61, _c0$3, ctx.form.controls.password.invalid && ctx.form.controls.password.dirty));
        ɵɵadvance(3);
        ɵɵproperty("ngClass", ɵɵpureFunction2(63, _c1$2, ctx.typeInputPass, !ctx.typeInputPass));
        ɵɵadvance(3);
        ɵɵclassMapInterpolate1("fas fa-", ctx.rule1, "circle");
        ɵɵclassProp("checked", ctx.rule1 === "check-")("uncheck", ctx.rule1 === "");
        ɵɵadvance(3);
        ɵɵclassMapInterpolate1("fas fa-", ctx.rule2, "circle");
        ɵɵclassProp("checked", ctx.rule2 === "check-")("uncheck", ctx.rule2 === "");
        ɵɵadvance(3);
        ɵɵclassMapInterpolate1("fas fa-", ctx.rule3, "circle");
        ɵɵclassProp("checked", ctx.rule3 === "check-")("uncheck", ctx.rule3 === "");
        ɵɵadvance(3);
        ɵɵclassMapInterpolate1("fas fa-", ctx.rule4, "circle");
        ɵɵclassProp("checked", ctx.rule4 === "check-")("uncheck", ctx.rule4 === "");
        ɵɵadvance(3);
        ɵɵclassMapInterpolate1("fas fa-", ctx.rule5, "circle");
        ɵɵclassProp("checked", ctx.rule5 === "check-")("uncheck", ctx.rule5 === "");
        ɵɵadvance(4);
        ɵɵproperty("innerHTML", ɵɵpipeBind2(36, 55, "@i18n-store-front-login-form-confirmPassword", ctx.lang), ɵɵsanitizeHtml);
        ɵɵadvance(5);
        ɵɵproperty("placeholder", ɵɵpipeBind2(41, 58, "@i18n-quote-createUser-form-label-confirmPassword", ctx.lang))("type", !ctx.typeInputPass2 ? "password" : "text")("ngClass", ɵɵpureFunction1(66, _c0$3, ctx.form.controls.password2.invalid && ctx.form.controls.password2.dirty));
        ɵɵadvance(3);
        ɵɵproperty("ngClass", ɵɵpureFunction2(68, _c1$2, ctx.typeInputPass2, !ctx.typeInputPass2));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.form.get("password2").errors);
        ɵɵadvance(4);
        ɵɵproperty("disabled", !ctx.form.valid || ctx.submit_disabled);
        ɵɵadvance(4);
        ɵɵproperty("ngIf", ctx.submit_disabled);
    } }, directives: [ɵangular_packages_forms_forms_y, NgControlStatusGroup, FormGroupDirective, DefaultValueAccessor, NgControlStatus, FormControlName, NgClass, NgIf], pipes: [I18nPipe], styles: [".box[_ngcontent-%COMP%]{width:25rem}@media (max-width:26.875rem){.box[_ngcontent-%COMP%]{width:30%}}.alert[_ngcontent-%COMP%]{border:1px solid transparent;border-radius:.25rem;margin-bottom:1rem;padding:.5rem 1rem;position:relative}.box[_ngcontent-%COMP%]{box-shadow:0 2px 1px 0 hsla(0,3.9%,80%,.2);margin-bottom:2rem;min-height:10rem}.box[_ngcontent-%COMP%], .box-head[_ngcontent-%COMP%]{color:#4a4a4a;font-size:.75rem;margin-left:auto;margin-right:auto;padding:15px}.box-head[_ngcontent-%COMP%]{box-shadow:0 2px 1px 0 rgba(0,0,0,.2);margin-bottom:2px;min-height:5rem}.box-header[_ngcontent-%COMP%]{margin-left:auto;margin-right:auto}.skin-white[_ngcontent-%COMP%]{background-color:#fff}@media (max-width:768px){.box[_ngcontent-%COMP%], .box-header[_ngcontent-%COMP%]{font-size:1rem!important}.section-title[_ngcontent-%COMP%]{font-size:.875rem!important}}@media (max-width:992px){.box[_ngcontent-%COMP%], .box-header[_ngcontent-%COMP%]{width:auto!important}}.title[_ngcontent-%COMP%]{font-size:1rem}.m-b-1[_ngcontent-%COMP%], .title[_ngcontent-%COMP%]{margin-bottom:1rem}.m-l-1[_ngcontent-%COMP%]{margin-left:1.5rem}.m-b-3[_ngcontent-%COMP%]{margin-bottom:3rem}.m-b-2[_ngcontent-%COMP%]{margin-bottom:2rem}.m-t-3[_ngcontent-%COMP%]{margin-top:3rem}.p-t-0[_ngcontent-%COMP%]{padding-top:0}.p-b-2[_ngcontent-%COMP%]{padding-bottom:2rem}.section-title[_ngcontent-%COMP%], .text-size-1[_ngcontent-%COMP%]{font-size:.7rem}.text-color-1[_ngcontent-%COMP%]{color:#000}.img-plan[_ngcontent-%COMP%]{background-color:#d8d8d8;border:1px solid #979797;float:left;height:197px;margin-right:1rem;width:159px}.plan-descripotion[_ngcontent-%COMP%]{border-bottom:.5px solid #ddd;margin-bottom:1rem;padding-bottom:1rem}.text-color-blue[_ngcontent-%COMP%]{color:#4a90e2}.text-color-gray[_ngcontent-%COMP%]{color:#4a4a4a}.text-size-1[_ngcontent-%COMP%]{font-size:1.2rem}.text-size-2[_ngcontent-%COMP%]{font-size:1.6rem}.checkbox[_ngcontent-%COMP%]{background-color:#fff;border:1px solid #ccc;border-radius:2px;height:16px;width:18px}.radius-client[_ngcontent-%COMP%]{border-radius:1rem;height:2rem;width:2rem}.link[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#4a4a4a}.link[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:focus, .link[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover{color:#bbb}.icon-search[_ngcontent-%COMP%]{margin-left:-1.5rem;margin-top:.6rem;position:absolute}.input-search[_ngcontent-%COMP%]{padding-right:2rem!important}.icon-status[_ngcontent-%COMP%]{background:#fff;border:.5px solid #ccc;border-radius:50px;font-size:.7rem;margin-left:1.5rem;padding:2px;position:absolute}.list-flex[_ngcontent-%COMP%]:hover   .radius-client[_ngcontent-%COMP%]{-webkit-transition:width 5s;border-radius:.7rem;transition:width 5s}.fz-1[_ngcontent-%COMP%]{font-size:.8rem}.cursor-pounter[_ngcontent-%COMP%]{cursor:pointer}.uncheck[_ngcontent-%COMP%]{color:#e1e0e0}.checked[_ngcontent-%COMP%]{color:#4a9961}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ChangePasswordComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-change-user-password',
                templateUrl: './change-password.component.html',
                styleUrls: ['./change-password.component.css']
            }]
    }], function () { return [{ type: ActivatedRoute }, { type: Router }, { type: FormBuilder }, { type: I18nPipe }, { type: AuthService }, { type: HttpService }, { type: ErrorService$1 }, { type: LocalService }]; }, { username: [{
            type: Input
        }], config: [{
            type: Input
        }], token: [{
            type: Input
        }], response: [{
            type: Output
        }] }); })();

function UnlockPasswordComponent_ng_container_18_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelement(1, "option", 16);
    ɵɵpipe(2, "i18n");
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const option_r4 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵproperty("value", option_r4 == null ? null : option_r4.identifier)("innerHTML", ɵɵpipeBind1(2, 3, option_r4 == null ? null : option_r4.description), ɵɵsanitizeHtml)("selected", option_r4 == null ? null : option_r4.selected);
} }
function UnlockPasswordComponent_div_19_div_5_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 5);
    ɵɵpipe(1, "i18n");
} if (rf & 2) {
    const ctx_r6 = ɵɵnextContext(3);
    ɵɵproperty("innerHTML", ɵɵpipeBind2(1, 1, "@i18n-store-front-login-error-field-required", ctx_r6.lang), ɵɵsanitizeHtml);
} }
function UnlockPasswordComponent_div_19_div_5_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 5);
    ɵɵpipe(1, "i18n");
} if (rf & 2) {
    const ctx_r7 = ɵɵnextContext(3);
    ɵɵproperty("innerHTML", ɵɵpipeBind2(1, 1, "@i18n-store-front-login-error-field-required", ctx_r7.lang), ɵɵsanitizeHtml);
} }
function UnlockPasswordComponent_div_19_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 19);
    ɵɵtemplate(1, UnlockPasswordComponent_div_19_div_5_div_1_Template, 2, 4, "div", 20);
    ɵɵtemplate(2, UnlockPasswordComponent_div_19_div_5_div_2_Template, 2, 4, "div", 20);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r5.form.get("mail").errors["required"] && !ctx_r5.form.get("mail").pristine);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r5.form.get("mail").errors["invalid"]);
} }
const _c0$4 = function (a0) { return { "error": a0 }; };
function UnlockPasswordComponent_div_19_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 8);
    ɵɵelement(1, "label", 9);
    ɵɵpipe(2, "i18n");
    ɵɵelement(3, "input", 17);
    ɵɵpipe(4, "i18n");
    ɵɵtemplate(5, UnlockPasswordComponent_div_19_div_5_Template, 3, 2, "div", 18);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 4, "@i18n-text-email"), ɵɵsanitizeHtml);
    ɵɵadvance(2);
    ɵɵproperty("placeholder", ɵɵpipeBind1(4, 6, "@i18n-text-input-email"))("ngClass", ɵɵpureFunction1(8, _c0$4, ctx_r1.form.controls.mail.invalid && ctx_r1.form.controls.mail.dirty));
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r1.form.get("mail").errors);
} }
function UnlockPasswordComponent_div_20_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 8);
    ɵɵelement(1, "label", 9);
    ɵɵpipe(2, "i18n");
    ɵɵelement(3, "input", 21);
    ɵɵpipe(4, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 3, "@i18n-text-username"), ɵɵsanitizeHtml);
    ɵɵadvance(2);
    ɵɵproperty("placeholder", ɵɵpipeBind1(4, 5, "@i18n-text-input-username"))("ngClass", ɵɵpureFunction1(7, _c0$4, ctx_r2.form.controls.username.invalid && ctx_r2.form.controls.username.dirty));
} }
function UnlockPasswordComponent_i_25_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "i", 22);
} }
class UnlockPasswordComponent {
    constructor(route, formBuilder, httpService, _error, localStorage) {
        this.route = route;
        this.formBuilder = formBuilder;
        this.httpService = httpService;
        this._error = _error;
        this.localStorage = localStorage;
        this.response = new EventEmitter();
        this.options = [
            {
                identifier: '1',
                description: '@i18n-text-mail',
                selected: true,
                active: true
            },
            {
                identifier: '2',
                description: '@i18n-text-username',
                selected: false,
                active: true
            }
        ];
        this.optionSelected = '1';
        this.submit_load = false;
    }
    ngOnInit() {
        this.form = this.formBuilder.group({
            method: ['', Validators.required],
            username: [''],
            mail: ['']
        });
    }
    change(evtn) {
        this.optionSelected = evtn.target.value;
    }
    submit() {
        this.submit_load = true;
        /* if (!(this.form.controls['method'].value === '1' && (this.form.controls['mail'].value !== undefined || this.form.controls['mail'].value !== null || this.form.controls['mail'].value !== ''))) {
           this.form.controls['mail'].setErrors({ 'invalid': true });
         }
         if (!(this.form.controls['method'].value === '2' && (this.form.controls['username'].value !== undefined || this.form.controls['username'].value !== null || this.form.controls['username'].value !== ''))) {
           this.form.controls['username'].setErrors({ 'invalid': true });
         }*/
        let obj = {};
        if (this.form.controls['method'].value === '1') {
            obj = {
                email: this.form.controls['mail'].value
            };
        }
        else {
            obj = {
                username: this.form.controls['username'].value
            };
        }
        this.params.endpoint.params.request = obj;
        this.httpService.executeRequest(this.params.endpoint.name, this.params.endpoint.params, true).subscribe((resp) => {
            this.submit_load = false;
            this.localStorage.setItem('date_now', new Date().toString());
            this.response.emit({
                response: 'success',
                data: resp
            });
        }, (error) => {
            const error_aux = error.error;
            this.submit_load = false;
            if (this.form.controls['method'].value === '1') {
                this.form.get('mail').setValue('');
                this.form.get('mail').patchValue('');
            }
            if (this.form.controls['method'].value === '2') {
                this.form.get('username').setValue('');
                this.form.get('username').patchValue('');
            }
            if (error_aux.name === 'BadCredentialsException') {
                this._error.show(JSON.parse(error.error), '@i18n-text-invalid-credentials', '@i18n-text-invalid-credentials-message');
            }
            else if (error_aux.name === 'RequiresManualUnlockingException') {
                this._error.show(JSON.parse(error.error), '@i18n-text-user-locked', '@i18n-text-user-locked-message-manual-unlocking');
                this.response.emit({
                    response: 'error',
                    data: {}
                });
            }
            else {
                this._error.show(JSON.parse(error.error));
            }
        });
    }
}
/** @nocollapse */ UnlockPasswordComponent.ɵfac = function UnlockPasswordComponent_Factory(t) { return new (t || UnlockPasswordComponent)(ɵɵdirectiveInject(ActivatedRoute), ɵɵdirectiveInject(FormBuilder), ɵɵdirectiveInject(HttpService), ɵɵdirectiveInject(ErrorService$1), ɵɵdirectiveInject(LocalService)); };
/** @nocollapse */ UnlockPasswordComponent.ɵcmp = ɵɵdefineComponent({ type: UnlockPasswordComponent, selectors: [["akeela-auth-unlock-password"]], inputs: { params: "params" }, outputs: { response: "response" }, decls: 27, vars: 22, consts: [[1, "fluid-container", "animated", "fadeIn"], [1, "flexbox-container"], [1, "ml-auto", "mr-auto"], [1, "teme-gray", "box"], [1, "title", "text-center", "font-weight-light", 3, "innerHTML"], [3, "innerHTML"], ["novalidate", "", 1, "text-left", 3, "formGroup", "ngSubmit"], [1, ""], [1, "form-group"], ["for", "exampleInputEmail1", 1, "label", 3, "innerHTML"], ["formControlName", "method", 1, "form-control", 3, "value", "ngClass", "change"], ["value", ""], [4, "ngFor", "ngForOf"], ["class", "form-group", 4, "ngIf"], ["type", "button", 1, "btn", "btn-block", "btn-primary", 3, "disabled", "click"], ["class", "fas fa-spinner fa-spin", 4, "ngIf"], [3, "value", "innerHTML", "selected"], ["type", "text", "formControlName", "mail", 1, "form-control", 3, "placeholder", "ngClass"], ["class", "form-control-feedback help-block", 4, "ngIf"], [1, "form-control-feedback", "help-block"], [3, "innerHTML", 4, "ngIf"], ["type", "text", "formControlName", "username", 1, "form-control", 3, "placeholder", "ngClass"], [1, "fas", "fa-spinner", "fa-spin"]], template: function UnlockPasswordComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelementStart(2, "div", 2);
        ɵɵelementStart(3, "div", 3);
        ɵɵelement(4, "h2", 4);
        ɵɵpipe(5, "i18n");
        ɵɵelement(6, "span", 5);
        ɵɵpipe(7, "i18n");
        ɵɵelement(8, "br");
        ɵɵelement(9, "br");
        ɵɵelementStart(10, "form", 6);
        ɵɵlistener("ngSubmit", function UnlockPasswordComponent_Template_form_ngSubmit_10_listener() { return ctx.submit(); });
        ɵɵelementStart(11, "div", 7);
        ɵɵelementStart(12, "div", 8);
        ɵɵelement(13, "label", 9);
        ɵɵpipe(14, "i18n");
        ɵɵelementStart(15, "select", 10);
        ɵɵlistener("change", function UnlockPasswordComponent_Template_select_change_15_listener($event) { return ctx.change($event); });
        ɵɵelementStart(16, "option", 11);
        ɵɵtext(17, "Seleccione");
        ɵɵelementEnd();
        ɵɵtemplate(18, UnlockPasswordComponent_ng_container_18_Template, 3, 5, "ng-container", 12);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵtemplate(19, UnlockPasswordComponent_div_19_Template, 6, 10, "div", 13);
        ɵɵtemplate(20, UnlockPasswordComponent_div_20_Template, 5, 9, "div", 13);
        ɵɵelement(21, "br");
        ɵɵelementStart(22, "button", 14);
        ɵɵlistener("click", function UnlockPasswordComponent_Template_button_click_22_listener() { return ctx.submit(); });
        ɵɵtext(23);
        ɵɵpipe(24, "i18n");
        ɵɵtemplate(25, UnlockPasswordComponent_i_25_Template, 1, 0, "i", 15);
        ɵɵelementEnd();
        ɵɵelement(26, "br");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(4);
        ɵɵproperty("innerHTML", ɵɵpipeBind1(5, 12, "@i18n-text-help-with-your-password"), ɵɵsanitizeHtml);
        ɵɵadvance(2);
        ɵɵproperty("innerHTML", ɵɵpipeBind1(7, 14, "@i18n-text-help-with-your-password-subtitle"), ɵɵsanitizeHtml);
        ɵɵadvance(4);
        ɵɵproperty("formGroup", ctx.form);
        ɵɵadvance(3);
        ɵɵproperty("innerHTML", ɵɵpipeBind1(14, 16, "@i18n-text-method-recovery"), ɵɵsanitizeHtml);
        ɵɵadvance(2);
        ɵɵproperty("value", ctx.optionSelected)("ngClass", ɵɵpureFunction1(20, _c0$4, ctx.form.controls.method.invalid && ctx.form.controls.method.dirty));
        ɵɵadvance(3);
        ɵɵproperty("ngForOf", ctx.options);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.optionSelected === "1");
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.optionSelected === "2");
        ɵɵadvance(2);
        ɵɵproperty("disabled", !ctx.form.valid || ctx.submit_load);
        ɵɵadvance(1);
        ɵɵtextInterpolate1(" ", ɵɵpipeBind1(24, 18, "@i18n-text-continue"), " ");
        ɵɵadvance(2);
        ɵɵproperty("ngIf", ctx.submit_load);
    } }, directives: [ɵangular_packages_forms_forms_y, NgControlStatusGroup, FormGroupDirective, SelectControlValueAccessor, NgControlStatus, FormControlName, NgClass, NgSelectOption, ɵangular_packages_forms_forms_x, NgForOf, NgIf, DefaultValueAccessor], pipes: [I18nPipe], styles: [".box[_ngcontent-%COMP%]{box-shadow:0 2px 4px 0 hsla(0,0%,60%,.5);margin-left:auto;margin-right:auto;margin-top:2rem;padding:3rem 1.5rem;width:25rem}.box[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{margin-bottom:2.5rem}@media (max-width:25.875rem){.box[_ngcontent-%COMP%]{width:100%}}.label2[_ngcontent-%COMP%]{font-size:.7rem;margin-top:.3rem}.link[_ngcontent-%COMP%]{font-size:.875rem}.ls[_ngcontent-%COMP%]{letter-spacing:-2px}.ls-o[_ngcontent-%COMP%]{color:#777}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(UnlockPasswordComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-auth-unlock-password',
                templateUrl: './unlock-password.component.html',
                styleUrls: ['./unlock-password.component.css']
            }]
    }], function () { return [{ type: ActivatedRoute }, { type: FormBuilder }, { type: HttpService }, { type: ErrorService$1 }, { type: LocalService }]; }, { params: [{
            type: Input
        }], response: [{
            type: Output
        }] }); })();

function CheckComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 17);
    ɵɵelementStart(1, "div", 18);
    ɵɵelementStart(2, "h2", 19);
    ɵɵtext(3);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(3);
    ɵɵtextInterpolate(ctx_r0.countdown.time.minutes + ":" + ctx_r0.countdown.time.seconds);
} }
function CheckComponent_div_17_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 6);
    ɵɵpipe(1, "i18n");
} if (rf & 2) {
    const ctx_r4 = ɵɵnextContext(2);
    ɵɵproperty("innerHTML", ɵɵpipeBind2(1, 1, "@i18n-store-front-login-error-field-required", ctx_r4.lang), ɵɵsanitizeHtml);
} }
function CheckComponent_div_17_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 6);
    ɵɵpipe(1, "i18n");
} if (rf & 2) {
    const ctx_r5 = ɵɵnextContext(2);
    ɵɵproperty("innerHTML", ɵɵpipeBind2(1, 1, "@i18n-store-front-login-error-field-required", ctx_r5.lang), ɵɵsanitizeHtml);
} }
function CheckComponent_div_17_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 20);
    ɵɵtemplate(1, CheckComponent_div_17_div_1_Template, 2, 4, "div", 21);
    ɵɵtemplate(2, CheckComponent_div_17_div_2_Template, 2, 4, "div", 21);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r1.form.get("code").errors["required"] && !ctx_r1.form.get("code").pristine);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r1.form.get("code").errors["invalid"]);
} }
function CheckComponent_i_21_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "i", 22);
} }
function CheckComponent_span_25_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span");
    ɵɵelement(1, "i", 23);
    ɵɵelementEnd();
} }
const _c0$5 = function (a0) { return { "error": a0 }; };
class CheckComponent {
    constructor(httpService, _error, countdown, _router, formBuilder, _activatedRoute, _alert, _i18n, localStorage) {
        this.httpService = httpService;
        this._error = _error;
        this.countdown = countdown;
        this._router = _router;
        this.formBuilder = formBuilder;
        this._activatedRoute = _activatedRoute;
        this._alert = _alert;
        this._i18n = _i18n;
        this.localStorage = localStorage;
        this.activeCountdown = false;
        this.response = new EventEmitter();
        this.resend_load = false;
        this.submit_load = false;
    }
    ngOnInit() {
        this.form = this.formBuilder.group({
            code: ['', Validators.required]
        });
        if (this.activeCountdown) {
            this.countdown.run_clock(this.time, localStorage.getItem('date_now') ? localStorage.getItem('date_now') : null).then((resp) => {
                this._error.show({
                    title: '@i18n-text-time-expired',
                    html: '@i18n-text-time-expired-message'
                });
                this.response.emit({
                    response: 'expired',
                    data: {}
                });
            });
        }
    }
    submit() {
        this.submit_load = true;
        if (this.form.valid) {
            var num = new Number(10);
            let code = this.form.controls['code'].value;
            console.log("code.toString()", code.toString());
            if (this.username) {
                this.params.submit.params.path = {
                    code: code.toString(),
                    attrPrefix: 'username',
                    attrValue: this.username
                };
            }
            if (this.email) {
                this.params.submit.params.path = {
                    code: code.toString(),
                    attrPrefix: 'email',
                    attrValue: this.email
                };
            }
            this.httpService.executeRequest(this.params.submit.name, this.params.submit.params, true).subscribe((resp) => {
                if (resp !== null) {
                    this.response.emit({
                        response: 'success',
                        data: resp
                    });
                }
                else {
                    this._alert.show({
                        title: '@i18n-text-invalid-code',
                        html: '@i18n-text-invalid-code-message'
                    });
                }
                this.submit_load = false;
            }, (error) => {
                this.submit_load = false;
                if (error.error.name === 'ValidationException') {
                    this._error.show(error, '@i18n-text-user-locked', '@i18n-text-user-locked-message');
                    this.response.emit({
                        response: 'expired',
                        data: {}
                    });
                }
                else if (error.error.name === 'RequiresManualUnlockingException') {
                    this._error.show(error, '@i18n-text-user-locked', '@i18n-text-user-locked-message');
                    this.response.emit({
                        response: 'locked',
                        data: {}
                    });
                }
                else if (error.error.name === 'NotFoundException') {
                    this._error.show(error, '@i18n-text-invalid-code', '@i18n-text-invalid-code-message');
                    this.form.reset();
                }
                else {
                    this._error.show(error);
                }
            });
        }
        else {
            this.submit_load = false;
            this.form.controls['code'].setErrors({ 'invalid': true });
            this.form.reset();
        }
    }
    resend() {
        this.resend_load = true;
        this.params.resend.params.path = {};
        this.params.resend.params.body = {};
        this.params.resend.params.request = {};
        if (this.username) {
            this.params.resend.params.path = {
                attrPrefix: 'username',
                attrValue: this.username
            };
        }
        if (this.email) {
            this.params.resend.params.path = {
                attrPrefix: 'email',
                attrValue: this.email
            };
        }
        this.httpService.executeRequest(this.params.resend.name, this.params.resend.params, true).subscribe((resp) => {
            this.resend_load = false;
            this._alert.show({
                title: this._i18n.transform('@i18n-text-send-notification'),
                html: this._i18n.transform('@i18n-text-resend-mail-recovery')
            });
        }, (error) => {
            this.resend_load = false;
            this._error.show(error.error);
        });
    }
}
/** @nocollapse */ CheckComponent.ɵfac = function CheckComponent_Factory(t) { return new (t || CheckComponent)(ɵɵdirectiveInject(HttpService), ɵɵdirectiveInject(ErrorService$1), ɵɵdirectiveInject(CountdownService), ɵɵdirectiveInject(Router), ɵɵdirectiveInject(FormBuilder), ɵɵdirectiveInject(ActivatedRoute), ɵɵdirectiveInject(AlertService), ɵɵdirectiveInject(I18nPipe), ɵɵdirectiveInject(LocalService)); };
/** @nocollapse */ CheckComponent.ɵcmp = ɵɵdefineComponent({ type: CheckComponent, selectors: [["akeela-auth-unlock-password-check"]], inputs: { params: "params", username: "username", email: "email", activeCountdown: "activeCountdown", time: "time" }, outputs: { response: "response" }, decls: 27, vars: 24, consts: [[1, "fluid-container", "animated", "fadeIn"], [1, "flexbox-container"], [1, "ml-auto", "mr-auto"], [1, "teme-gray", "box"], ["class", "row", 4, "ngIf"], [1, "title", "text-center", "font-weight-light", 3, "innerHTML"], [3, "innerHTML"], ["novalidate", "", 1, "text-left", 3, "formGroup", "ngSubmit"], [1, ""], [1, "form-group"], ["for", "exampleInputEmail1", 1, "label", 3, "innerHTML"], ["type", "text", "placeholder", "", "formControlName", "code", 1, "form-control", 3, "ngClass"], ["class", "form-control-feedback help-block", 4, "ngIf"], ["type", "button", 1, "btn", "btn-block", "btn-primary", 3, "disabled", "click"], ["class", "fas fa-spinner fa-spin", 4, "ngIf"], ["href", "javascript:void()", 1, "float-left", "font-weight-normal", 3, "innerHTML", "click"], [4, "ngIf"], [1, "row"], [1, "col-12"], [1, "pull-right"], [1, "form-control-feedback", "help-block"], [3, "innerHTML", 4, "ngIf"], [1, "fas", "fa-spinner", "fa-spin"], [1, "fa", "fa-spinner", "fa-spin"]], template: function CheckComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelementStart(2, "div", 2);
        ɵɵelementStart(3, "div", 3);
        ɵɵtemplate(4, CheckComponent_div_4_Template, 4, 1, "div", 4);
        ɵɵelement(5, "h2", 5);
        ɵɵpipe(6, "i18n");
        ɵɵelement(7, "span", 6);
        ɵɵpipe(8, "i18n");
        ɵɵelement(9, "br");
        ɵɵelement(10, "br");
        ɵɵelementStart(11, "form", 7);
        ɵɵlistener("ngSubmit", function CheckComponent_Template_form_ngSubmit_11_listener() { return ctx.submit(); });
        ɵɵelementStart(12, "div", 8);
        ɵɵelementStart(13, "div", 9);
        ɵɵelement(14, "label", 10);
        ɵɵpipe(15, "i18n");
        ɵɵelement(16, "input", 11);
        ɵɵtemplate(17, CheckComponent_div_17_Template, 3, 2, "div", 12);
        ɵɵelementEnd();
        ɵɵelementStart(18, "button", 13);
        ɵɵlistener("click", function CheckComponent_Template_button_click_18_listener() { return ctx.submit(); });
        ɵɵtext(19);
        ɵɵpipe(20, "i18n");
        ɵɵtemplate(21, CheckComponent_i_21_Template, 1, 0, "i", 14);
        ɵɵelementEnd();
        ɵɵelement(22, "br");
        ɵɵelementStart(23, "a", 15);
        ɵɵlistener("click", function CheckComponent_Template_a_click_23_listener() { return ctx.resend(); });
        ɵɵpipe(24, "i18n");
        ɵɵtemplate(25, CheckComponent_span_25_Template, 2, 0, "span", 16);
        ɵɵelementEnd();
        ɵɵelement(26, "br");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(4);
        ɵɵproperty("ngIf", ctx.activeCountdown);
        ɵɵadvance(1);
        ɵɵproperty("innerHTML", ɵɵpipeBind1(6, 12, "@i18n-text-identity-validation"), ɵɵsanitizeHtml);
        ɵɵadvance(2);
        ɵɵproperty("innerHTML", ɵɵpipeBind1(8, 14, "@i18n-text-identity-validation-subtitle"), ɵɵsanitizeHtml);
        ɵɵadvance(4);
        ɵɵproperty("formGroup", ctx.form);
        ɵɵadvance(3);
        ɵɵproperty("innerHTML", ɵɵpipeBind1(15, 16, "@i18n-text-input-code"), ɵɵsanitizeHtml);
        ɵɵadvance(2);
        ɵɵproperty("ngClass", ɵɵpureFunction1(22, _c0$5, ctx.form.controls.code.invalid && ctx.form.controls.code.dirty));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.form.get("code").errors);
        ɵɵadvance(1);
        ɵɵproperty("disabled", !ctx.form.valid || ctx.submit_load);
        ɵɵadvance(1);
        ɵɵtextInterpolate1(" ", ɵɵpipeBind1(20, 18, "@i18n-text-continue"), " ");
        ɵɵadvance(2);
        ɵɵproperty("ngIf", ctx.submit_load);
        ɵɵadvance(2);
        ɵɵproperty("innerHTML", ɵɵpipeBind1(24, 20, "@i18n-text-resend-code"), ɵɵsanitizeHtml);
        ɵɵadvance(2);
        ɵɵproperty("ngIf", ctx.resend_load);
    } }, directives: [NgIf, ɵangular_packages_forms_forms_y, NgControlStatusGroup, FormGroupDirective, DefaultValueAccessor, NgControlStatus, FormControlName, NgClass], pipes: [I18nPipe], styles: [".box[_ngcontent-%COMP%]{box-shadow:0 2px 4px 0 hsla(0,0%,60%,.5);margin-left:auto;margin-right:auto;margin-top:2rem;padding:3rem 1.5rem;width:25rem}.box[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{margin-bottom:2.5rem}@media (max-width:25.875rem){.box[_ngcontent-%COMP%]{width:100%}}.label2[_ngcontent-%COMP%]{font-size:.7rem;margin-top:.3rem}.link[_ngcontent-%COMP%]{font-size:.875rem}.ls[_ngcontent-%COMP%]{letter-spacing:-2px}.ls-o[_ngcontent-%COMP%]{color:#777}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CheckComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-auth-unlock-password-check',
                templateUrl: './check.component.html',
                styleUrls: ['./check.component.css']
            }]
    }], function () { return [{ type: HttpService }, { type: ErrorService$1 }, { type: CountdownService }, { type: Router }, { type: FormBuilder }, { type: ActivatedRoute }, { type: AlertService }, { type: I18nPipe }, { type: LocalService }]; }, { params: [{
            type: Input
        }], username: [{
            type: Input
        }], email: [{
            type: Input
        }], activeCountdown: [{
            type: Input
        }], time: [{
            type: Input
        }], response: [{
            type: Output
        }] }); })();

function CheckQuestionComponent_div_9_div_5_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 3);
    ɵɵpipe(1, "i18n");
} if (rf & 2) {
    const ctx_r4 = ɵɵnextContext(3);
    ɵɵproperty("innerHTML", ɵɵpipeBind2(1, 1, "@i18n-store-front-login-error-field-required", ctx_r4.lang), ɵɵsanitizeHtml);
} }
function CheckQuestionComponent_div_9_div_5_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 3);
    ɵɵpipe(1, "i18n");
} if (rf & 2) {
    const ctx_r5 = ɵɵnextContext(3);
    ɵɵproperty("innerHTML", ɵɵpipeBind2(1, 1, "@i18n-store-front-login-error-field-required", ctx_r5.lang), ɵɵsanitizeHtml);
} }
function CheckQuestionComponent_div_9_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 14);
    ɵɵtemplate(1, CheckQuestionComponent_div_9_div_5_div_1_Template, 2, 4, "div", 15);
    ɵɵtemplate(2, CheckQuestionComponent_div_9_div_5_div_2_Template, 2, 4, "div", 15);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r2.form.get("code").errors["required"] && !ctx_r2.form.get("code").pristine);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r2.form.get("code").errors["invalid"]);
} }
function CheckQuestionComponent_div_9_i_9_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "i", 16);
} }
const _c0$6 = function (a0) { return { "error": a0 }; };
function CheckQuestionComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 7);
    ɵɵelementStart(1, "div", 8);
    ɵɵelement(2, "label", 9);
    ɵɵpipe(3, "i18n");
    ɵɵelement(4, "input", 10);
    ɵɵtemplate(5, CheckQuestionComponent_div_9_div_5_Template, 3, 2, "div", 11);
    ɵɵelementEnd();
    ɵɵelementStart(6, "button", 12);
    ɵɵlistener("click", function CheckQuestionComponent_div_9_Template_button_click_6_listener() { ɵɵrestoreView(_r7); const ctx_r6 = ɵɵnextContext(); return ctx_r6.submit(); });
    ɵɵtext(7);
    ɵɵpipe(8, "i18n");
    ɵɵtemplate(9, CheckQuestionComponent_div_9_i_9_Template, 1, 0, "i", 13);
    ɵɵelementEnd();
    ɵɵelement(10, "br");
    ɵɵelement(11, "br");
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(2);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(3, 6, ctx_r0.question == null ? null : ctx_r0.question.name), ɵɵsanitizeHtml);
    ɵɵadvance(2);
    ɵɵproperty("ngClass", ɵɵpureFunction1(10, _c0$6, ctx_r0.form.controls.code.invalid && ctx_r0.form.controls.code.dirty));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.form.get("code").errors);
    ɵɵadvance(1);
    ɵɵproperty("disabled", !ctx_r0.form.valid || ctx_r0.submit_load);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind1(8, 8, "@i18n-text-continue"), " ");
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r0.submit_load);
} }
function CheckQuestionComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 17);
    ɵɵelementStart(1, "div", 18);
    ɵɵelement(2, "img", 19);
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
class CheckQuestionComponent {
    constructor(httpService, _error, _router, formBuilder, _activatedRoute) {
        this.httpService = httpService;
        this._error = _error;
        this._router = _router;
        this.formBuilder = formBuilder;
        this._activatedRoute = _activatedRoute;
        this.response = new EventEmitter();
        this.submit_load = false;
    }
    ngOnInit() {
        this.form = this.formBuilder.group({
            code: ['', Validators.required]
        });
        this.generate_question();
    }
    generate_question() {
        this.httpService.executeRequest(this.params.question.name, this.params.question.params, true).subscribe((resp) => {
            this.question = resp;
        });
    }
    submit() {
        this.submit_load = true;
        if (this.form.valid) {
            if (this.username) {
                this.params.submit.params.path = {
                    answer: this.form.controls['code'].value,
                    attrPrefix: 'username',
                    attrValue: this.username,
                    identifierQuestion: this.question.identifier
                };
            }
            if (this.email) {
                this.params.submit.params.path = {
                    code: this.form.controls['code'].value,
                    attrPrefix: 'email',
                    attrValue: this.email,
                    identifierQuestion: this.question.identifier
                };
            }
            this.httpService.executeRequest(this.params.submit.name, this.params.submit.params, true).subscribe((resp) => {
                this.submit_load = false;
                this.response.emit({
                    response: 'success',
                    data: resp
                });
            }, (error) => {
                this.submit_load = false;
                if (error.error.name === 'ValidationException') {
                    this._error.show(error, '@i18n-text-user-code-expired', '@i18n-text-user-code-expired-message');
                    this.response.emit({
                        response: 'error',
                        data: {}
                    });
                }
                else if (error.error.name === 'RequiresManualUnlockingException') {
                    this._error.show(error, '@i18n-text-response-invalid', '@i18n-text-response-invalid-message');
                    this.response.emit({
                        response: 'error',
                        data: {}
                    });
                }
                else if (error.error.name === 'SystemQuestionFailedException') {
                    this._error.show(error, 'Respuesta inválida', '');
                    this.question = null;
                    this.form.controls['code'].setValue('');
                    this.form.controls['code'].patchValue('');
                    this.generate_question();
                }
                else if (error.error.name === 'NotFoundException') {
                    this._error.show(error, '@i18n-text-invalid-code', '@i18n-text-invalid-code-message');
                }
                else {
                    this.generate_question();
                    this._error.show(error);
                    this.response.emit({
                        response: 'error',
                        data: {}
                    });
                }
            });
        }
        else {
            this.submit_load = false;
            this.form.controls['code'].setErrors({ 'invalid': true });
        }
    }
}
/** @nocollapse */ CheckQuestionComponent.ɵfac = function CheckQuestionComponent_Factory(t) { return new (t || CheckQuestionComponent)(ɵɵdirectiveInject(HttpService), ɵɵdirectiveInject(ErrorService$1), ɵɵdirectiveInject(Router), ɵɵdirectiveInject(FormBuilder), ɵɵdirectiveInject(ActivatedRoute)); };
/** @nocollapse */ CheckQuestionComponent.ɵcmp = ɵɵdefineComponent({ type: CheckQuestionComponent, selectors: [["akeela-auth-unlock-password-check-question"]], inputs: { params: "params", username: "username", email: "email" }, outputs: { response: "response" }, decls: 11, vars: 9, consts: [[1, "container-fluid", "main-content", "animated", "fadeIn"], [1, "teme-gray", "box"], [1, "title", "text-center", "font-weight-light", 3, "innerHTML"], [3, "innerHTML"], ["novalidate", "", 1, "text-left", 3, "formGroup", "ngSubmit"], ["class", "", 4, "ngIf"], ["class", "row", 4, "ngIf"], [1, ""], [1, "form-group"], ["for", "exampleInputEmail1", 1, "label", 3, "innerHTML"], ["type", "text", "placeholder", "", "formControlName", "code", 1, "form-control", 3, "ngClass"], ["class", "form-control-feedback help-block", 4, "ngIf"], ["type", "button", 1, "btn", "btn-block", "btn-primary", 3, "disabled", "click"], ["class", "fas fa-spinner fa-spin", 4, "ngIf"], [1, "form-control-feedback", "help-block"], [3, "innerHTML", 4, "ngIf"], [1, "fas", "fa-spinner", "fa-spin"], [1, "row"], [1, "col-12", "p-t-1", "p-b-1"], ["src", "/assets/public/images/loading-2.gif ", "alt", " ", 1, "mx-auto", "d-block", 2, "width", "70px", "margin-bottom", "50px"]], template: function CheckQuestionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelement(2, "h2", 2);
        ɵɵpipe(3, "i18n");
        ɵɵelement(4, "span", 3);
        ɵɵpipe(5, "i18n");
        ɵɵelement(6, "br");
        ɵɵelement(7, "br");
        ɵɵelementStart(8, "form", 4);
        ɵɵlistener("ngSubmit", function CheckQuestionComponent_Template_form_ngSubmit_8_listener() { return ctx.submit(); });
        ɵɵtemplate(9, CheckQuestionComponent_div_9_Template, 12, 12, "div", 5);
        ɵɵtemplate(10, CheckQuestionComponent_div_10_Template, 3, 0, "div", 6);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(2);
        ɵɵproperty("innerHTML", ɵɵpipeBind1(3, 5, "@i18n-text-thanks"), ɵɵsanitizeHtml);
        ɵɵadvance(2);
        ɵɵproperty("innerHTML", ɵɵpipeBind1(5, 7, "@i18n-text-check-question-subtitle"), ɵɵsanitizeHtml);
        ɵɵadvance(4);
        ɵɵproperty("formGroup", ctx.form);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.question);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", !ctx.question);
    } }, directives: [ɵangular_packages_forms_forms_y, NgControlStatusGroup, FormGroupDirective, NgIf, DefaultValueAccessor, NgControlStatus, FormControlName, NgClass], pipes: [I18nPipe], styles: [".box[_ngcontent-%COMP%]{box-shadow:0 2px 4px 0 hsla(0,0%,60%,.5);margin-left:auto;margin-right:auto;margin-top:2rem;padding:3rem 1.5rem;width:25rem}.box[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{margin-bottom:2.5rem}@media (max-width:25.875rem){.box[_ngcontent-%COMP%]{width:100%}}.label2[_ngcontent-%COMP%]{font-size:.7rem;margin-top:.3rem}.link[_ngcontent-%COMP%]{font-size:.875rem}.ls[_ngcontent-%COMP%]{letter-spacing:-2px}.ls-o[_ngcontent-%COMP%]{color:#777}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CheckQuestionComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-auth-unlock-password-check-question',
                templateUrl: './check-question.component.html',
                styleUrls: ['./check-question.component.css']
            }]
    }], function () { return [{ type: HttpService }, { type: ErrorService$1 }, { type: Router }, { type: FormBuilder }, { type: ActivatedRoute }]; }, { params: [{
            type: Input
        }], username: [{
            type: Input
        }], email: [{
            type: Input
        }], response: [{
            type: Output
        }] }); })();

class ContentDirective {
    constructor() {
    }
}
/** @nocollapse */ ContentDirective.ɵfac = function ContentDirective_Factory(t) { return new (t || ContentDirective)(); };
/** @nocollapse */ ContentDirective.ɵdir = ɵɵdefineDirective({ type: ContentDirective, selectors: [["", "auth-akeela-content", ""]], inputs: { componentName: "componentName" } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ContentDirective, [{
        type: Directive,
        args: [{
                selector: '[auth-akeela-content]'
            }]
    }], function () { return []; }, { componentName: [{
            type: Input
        }] }); })();

class AkeelaTemplateComponent {
    constructor(templateService) {
        this.templateService = templateService;
    }
    ngOnInit() {
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.contentsRef.forEach((item, index) => {
                const template = this.templatesRef.find((_template, templateIndex) => templateIndex === index);
                this.templateService.addTemplate(item.componentName, template);
            });
        }, 10);
    }
}
/** @nocollapse */ AkeelaTemplateComponent.ɵfac = function AkeelaTemplateComponent_Factory(t) { return new (t || AkeelaTemplateComponent)(ɵɵdirectiveInject(AkeelaTemplateService)); };
/** @nocollapse */ AkeelaTemplateComponent.ɵcmp = ɵɵdefineComponent({ type: AkeelaTemplateComponent, selectors: [["auth-akeela-template"]], contentQueries: function AkeelaTemplateComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵɵcontentQuery(dirIndex, ContentDirective, false);
        ɵɵcontentQuery(dirIndex, ContentDirective, false, TemplateRef);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.contentsRef = _t);
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.templatesRef = _t);
    } }, decls: 1, vars: 0, template: function AkeelaTemplateComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementContainer(0);
    } }, styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AkeelaTemplateComponent, [{
        type: Component,
        args: [{
                selector: 'auth-akeela-template',
                templateUrl: './akeela-template.component.html',
                styleUrls: ['./akeela-template.component.css']
            }]
    }], function () { return [{ type: AkeelaTemplateService }]; }, { contentsRef: [{
            type: ContentChildren,
            args: [ContentDirective]
        }], templatesRef: [{
            type: ContentChildren,
            args: [ContentDirective, { read: TemplateRef }]
        }] }); })();

class AkeelaAuthModule {
    constructor(parentModule) {
        if (parentModule) {
            throw new Error('AkeelaAuthModule is already loaded. Import it in the AppModule only');
        }
    }
    static config(config) {
        return {
            ngModule: AkeelaAuthModule,
            providers: [
                { provide: AuthConfig, useValue: config }
            ]
        };
    }
}
/** @nocollapse */ AkeelaAuthModule.ɵmod = ɵɵdefineNgModule({ type: AkeelaAuthModule });
/** @nocollapse */ AkeelaAuthModule.ɵinj = ɵɵdefineInjector({ factory: function AkeelaAuthModule_Factory(t) { return new (t || AkeelaAuthModule)(ɵɵinject(AkeelaAuthModule, 12)); }, providers: [
        AkeelaTemplateService,
        ErrorService,
        AuthService,
        AuthConfigService,
        KeepAliveService
    ], imports: [[
            CommonModule,
            I18nModule,
            FormsModule,
            ReactiveFormsModule,
            AlertModule,
            SweetAlert2Module.forRoot(),
            NgIdleKeepaliveModule.forRoot()
        ]] });
__decorate([
    __param(0, Optional()),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [AuthConfig]),
    __metadata("design:returntype", Object)
], AkeelaAuthModule, "config", null);
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(AkeelaAuthModule, { declarations: [CreateUserPasswordComponent,
        RecoveryPasswordComponent,
        LoginComponent,
        AkeelaTemplateComponent,
        ContentDirective,
        UnlockPasswordComponent,
        CheckComponent,
        CheckQuestionComponent,
        KeepaliveComponent,
        ChangePasswordComponent], imports: [CommonModule,
        I18nModule,
        FormsModule,
        ReactiveFormsModule,
        AlertModule, SweetAlert2Module, NgIdleKeepaliveModule], exports: [CreateUserPasswordComponent,
        RecoveryPasswordComponent,
        LoginComponent,
        AkeelaTemplateComponent,
        ContentDirective,
        UnlockPasswordComponent,
        CheckComponent,
        CheckQuestionComponent,
        KeepaliveComponent,
        ChangePasswordComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(AkeelaAuthModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    I18nModule,
                    FormsModule,
                    ReactiveFormsModule,
                    AlertModule,
                    SweetAlert2Module.forRoot(),
                    NgIdleKeepaliveModule.forRoot()
                ],
                declarations: [
                    CreateUserPasswordComponent,
                    RecoveryPasswordComponent,
                    LoginComponent,
                    AkeelaTemplateComponent,
                    ContentDirective,
                    UnlockPasswordComponent,
                    CheckComponent,
                    CheckQuestionComponent,
                    KeepaliveComponent,
                    ChangePasswordComponent
                ],
                providers: [
                    AkeelaTemplateService,
                    ErrorService,
                    AuthService,
                    AuthConfigService,
                    KeepAliveService
                ],
                exports: [
                    CreateUserPasswordComponent,
                    RecoveryPasswordComponent,
                    LoginComponent,
                    AkeelaTemplateComponent,
                    ContentDirective,
                    UnlockPasswordComponent,
                    CheckComponent,
                    CheckQuestionComponent,
                    KeepaliveComponent,
                    ChangePasswordComponent
                ]
            }]
    }], function () { return [{ type: AkeelaAuthModule, decorators: [{
                type: Optional
            }, {
                type: SkipSelf
            }] }]; }, null); })();

/*
 * Public API Surface of akeela-security
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AkeelaAuthModule, AkeelaTemplateComponent, AkeelaTemplateService, AuthConfigService, AuthService, ChangePasswordComponent, CheckComponent, CheckQuestionComponent, ContentDirective, CreateUserPasswordComponent, ErrorService, KeepAliveService, KeepaliveComponent, LoginComponent, RecoveryPasswordComponent, TOKEN_NAME, UnlockPasswordComponent };
//# sourceMappingURL=akeela-auth.js.map
